/**
 * @license
 * Copyright (c) 2018 Crius Authors. All rights reserved.
 */

import '@polymer/polymer/polymer-element.js';

// eslint-disable-next-line camelcase
const $_documentContainer = document.createElement('template');
$_documentContainer.innerHTML = `
<dom-module id="cs-shared-styles-base-common">
    <template>
		<custom-style>
			<style>
                *,
                ::after,
                ::before,
                :host {
                    box-sizing: border-box
                }

                :host {
                    color: var(--cs-dark-color);
                    font-family: var(--cs-theme-primary-font-family);
                    font-size: var(--cs-theme-body-font-size-mobile);
                    -webkit-font-smoothing: antialiased;
                    line-height: var(--cs-theme-body-line-height-mobile)
                }

                :host([text-color=light]) {
                    color: var(--cs-light-color)
                }

                @media only screen and (min-width:1024px) {
                    :host {
                        font-size: var(--cs-theme-body-font-size-tablet-landscape);
                        line-height: var(--cs-theme-body-line-height-tablet-landscape)
                    }
                }

                @media only screen and (min-width:1456px) {
                    :host {
                        font-size: var(--cs-theme-body-font-size-desktop);
                        line-height: var(--cs-theme-body-line-height-desktop)
                    }
                }

                [hidden] {
                    display: none !important
                }


                :host {
                    --cs-interface-expansion: 0.1s;
                    --cs-transition-duration: 0.3s;
                    --cs-transition-easing: cubic-bezier(0.25, 0.1, 0.25, 1)
                }

                :host  {
                  --cs-theme-cs-brand-2017-pink: #ff1e3c;
                  --cs-theme-cs-brand-2017-dark-gradient: #fc2442;
                  --cs-theme-cs-brand-2017-light-gradient: #fc2442;
                  --cs-theme-cs-brand-2020-coral: #ff4747;
                  --cs-theme-cs-brand-2020-coral-rgb: 255, 71, 71;
                  --cs-theme-cs-brand-2020-deep-blue: #0d1042;
                  --cs-theme-color: var(--cs-theme-cs-brand-2020-coral);
                  --cs-theme-dark-gradient: var(--cs-theme-color);
                  --cs-theme-light-gradient: var(--cs-theme-color);
                  --cs-theme-cs-corporate-header-font-family: "roboto", "Verdana",
                    "Helvetica", "Arial", sans-serif;
                  --cs-theme-cs-corporate-body-font-family: "ElectronicArtsText", "Verdana",
                    "Helvetica", "Arial", sans-serif;
                  --cs-theme-header-font-family: "roboto-condensed", "Verdana", "Helvetica",
                    "Arial", sans-serif;
                  --cs-theme-header-font-weight-normal: 400;
                  --cs-theme-header-font-weight-bold: 600;
                  --cs-theme-header-letter-spacing: normal;
                  --cs-theme-header-line-height-mobile: 1.25;
                  --cs-theme-header-line-height-tablet: var(
                    --cs-theme-header-line-height-mobile
                  );
                  --cs-theme-header-line-height-desktop: 1.35;
                  --cs-theme-body-font-family: "roboto";
                  --cs-theme-body-font-weight-light: 300;
                  --cs-theme-body-font-weight-normal: 400;
                  --cs-theme-body-font-weight-bold: 600;
                  --cs-theme-body-letter-spacing: normal;
                  --cs-text-case: uppercase;
                  --cs-theme-primary-font-family: var(--cs-theme-body-font-family);
                  --cs-theme-secondary-font-family: var(--cs-theme-header-font-family);
                  --cs-theme-typographic-headings-font-family: var(
                    --cs-theme-header-font-family
                  );
                  --cs-theme-body-font-size-mobile: 16px;
                  --cs-theme-body-font-size-tablet-landscape: 18px;
                  --cs-theme-body-font-size-desktop: 18px;
                  --cs-theme-body-letter-spacing-mobile: var(--cs-theme-body-letter-spacing);
                  --cs-theme-body-letter-spacing-tablet-landscape: var(
                    --cs-theme-body-letter-spacing
                  );
                  --cs-theme-body-letter-spacing-desktop: var(--cs-theme-body-letter-spacing);
                  --cs-theme-body-line-height-mobile: 1.65;
                  --cs-theme-body-line-height-tablet-landscape: 1.5;
                  --cs-theme-body-line-height-desktop: 1.5;
                  --cs-theme-display-font-style: normal;
                  --cs-theme-display-font-weight: var(--cs-theme-header-font-weight-bold);
                  --cs-theme-display-letter-spacing: normal;
                  --cs-theme-display-line-height: 1.15;
                  --cs-theme-label-font-weight: var(--cs-theme-header-font-weight-bold);
                  --cs-theme-label-letter-spacing: normal;
                  --cs-theme-label-line-height-mobile: 1.35;
                  --cs-theme-label-line-height-tablet: 1.35;
                  --cs-theme-label-line-height-desktop: 1.35;
                  --cs-theme-h1-font-size-mobile: 40px;
                  --cs-theme-h1-font-size-tablet-landscape: 44px;
                  --cs-theme-h1-font-size-desktop: 48px;
                  --cs-theme-h1-font-weight: var(--cs-theme-header-font-weight-normal);
                  --cs-theme-h1-letter-spacing: var(--cs-theme-header-letter-spacing);
                  --cs-theme-h1-letter-spacing-mobile: var(--cs-theme-header-letter-spacing);
                  --cs-theme-h1-letter-spacing-tablet-landscape: var(
                    --cs-theme-header-letter-spacing
                  );
                  --cs-theme-h1-letter-spacing-desktop: var(--cs-theme-header-letter-spacing);
                  --cs-theme-h1-line-height-mobile: var(--cs-theme-header-line-height-mobile);
                  --cs-theme-h1-line-height-tablet-landscape: var(
                    --cs-theme-header-line-height-tablet
                  );
                  --cs-theme-h1-line-height-desktop: var(--cs-theme-header-line-height-desktop);
                  --cs-theme-h1-margin-mobile: 0.65em 0;
                  --cs-theme-h1-margin-tablet-portrait: 0.65em 0;
                  --cs-theme-h1-margin-tablet-landscape: 0.65em 0;
                  --cs-theme-h1-margin-desktop: 0.65em 0;
                  --cs-theme-h2-font-size-mobile: 32px;
                  --cs-theme-h2-font-size-tablet-landscape: 36px;
                  --cs-theme-h2-font-size-desktop: 40px;
                  --cs-theme-h2-font-weight: var(--cs-theme-header-font-weight-normal);
                  --cs-theme-h2-letter-spacing: var(--cs-theme-header-letter-spacing);
                  --cs-theme-h2-letter-spacing-mobile: var(--cs-theme-header-letter-spacing);
                  --cs-theme-h2-letter-spacing-tablet-landscape: var(
                    --cs-theme-header-letter-spacing
                  );
                  --cs-theme-h2-letter-spacing-desktop: var(--cs-theme-header-letter-spacing);
                  --cs-theme-h2-line-height-mobile: var(--cs-theme-header-line-height-mobile);
                  --cs-theme-h2-line-height-tablet-landscape: var(
                    --cs-theme-header-line-height-tablet
                  );
                  --cs-theme-h2-line-height-desktop: var(--cs-theme-header-line-height-desktop);
                  --cs-theme-h2-margin-mobile: 0.65em 0;
                  --cs-theme-h2-margin-tablet-portrait: 0.65em 0;
                  --cs-theme-h2-margin-tablet-landscape: 0.65em 0;
                  --cs-theme-h2-margin-desktop: 0.65em 0;
                  --cs-theme-h2-after-l2-margin-top-mobile: 0.35em;
                  --cs-theme-h2-after-l2-margin-top-tablet-landscape: 0.35em;
                  --cs-theme-h2-after-l2-margin-top-desktop: 0.35em;
                  --cs-theme-h3-font-size-mobile: 28px;
                  --cs-theme-h3-font-size-tablet-landscape: 32px;
                  --cs-theme-h3-font-size-desktop: 36px;
                  --cs-theme-h3-font-weight: var(--cs-theme-header-font-weight-normal);
                  --cs-theme-h3-letter-spacing: var(--cs-theme-header-letter-spacing);
                  --cs-theme-h3-letter-spacing-mobile: var(--cs-theme-header-letter-spacing);
                  --cs-theme-h3-letter-spacing-tablet-landscape: var(
                    --cs-theme-header-letter-spacing
                  );
                  --cs-theme-h3-letter-spacing-desktop: var(--cs-theme-header-letter-spacing);
                  --cs-theme-h3-line-height-mobile: var(--cs-theme-header-line-height-mobile);
                  --cs-theme-h3-line-height-tablet-landscape: var(
                    --cs-theme-header-line-height-tablet
                  );
                  --cs-theme-h3-line-height-desktop: var(--cs-theme-header-line-height-desktop);
                  --cs-theme-h3-margin-mobile: 0.75em 0;
                  --cs-theme-h3-margin-tablet-portrait: 0.75em 0;
                  --cs-theme-h3-margin-tablet-landscape: 0.75em 0;
                  --cs-theme-h3-margin-desktop: 0.75em 0;
                  --cs-theme-h4-font-weight: var(--cs-theme-header-font-weight-normal);
                  --cs-theme-h4-font-size-mobile: 20px;
                  --cs-theme-h4-font-size-tablet-landscape: 24px;
                  --cs-theme-h4-font-size-desktop: 24px;
                  --cs-theme-h4-letter-spacing: var(--cs-theme-header-letter-spacing);
                  --cs-theme-h4-letter-spacing-mobile: var(--cs-theme-header-letter-spacing);
                  --cs-theme-h4-letter-spacing-tablet-landscape: var(
                    --cs-theme-header-letter-spacing
                  );
                  --cs-theme-h4-letter-spacing-desktop: var(--cs-theme-header-letter-spacing);
                  --cs-theme-h4-line-height-mobile: var(--cs-theme-header-line-height-mobile);
                  --cs-theme-h4-line-height-tablet-landscape: var(
                    --cs-theme-header-line-height-tablet
                  );
                  --cs-theme-h4-line-height-desktop: var(--cs-theme-header-line-height-desktop);
                  --cs-theme-h4-margin-mobile: 0.65em 0;
                  --cs-theme-h4-margin-tablet-portrait: 0.65em 0;
                  --cs-theme-h4-margin-tablet-landscape: 0.65em 0;
                  --cs-theme-h4-margin-desktop: 0.65em 0;
                  --cs-theme-h4-after-d1-margin-top-mobile: 0.75em;
                  --cs-theme-h4-after-d1-margin-top-tablet-portrait: 0.75em;
                  --cs-theme-h4-after-d1-margin-top-tablet-landscape: 0.75em;
                  --cs-theme-h4-after-d1-margin-top-desktop: 0.75em;
                  --cs-theme-h4-after-d2-margin-top-mobile: 0.65em;
                  --cs-theme-h4-after-d2-margin-top-tablet-portrait: 0.65em;
                  --cs-theme-h4-after-d2-margin-top-tablet-landscape: 0.65em;
                  --cs-theme-h4-after-d2-margin-top-desktop: 0.65em;
                  --cs-theme-h4-after-d3-margin-top-mobile: 0.65em;
                  --cs-theme-h4-after-d3-margin-top-tablet-portrait: 0.65em;
                  --cs-theme-h4-after-d3-margin-top-tablet-landscape: 0.65em;
                  --cs-theme-h4-after-d3-margin-top-desktop: 0.65em;
                  --cs-theme-h4-after-d4-margin-top-mobile: 0.65em;
                  --cs-theme-h4-after-d4-margin-top-tablet-landscape: 0.65em;
                  --cs-theme-h4-after-d4-margin-top-desktop: 0.65em;
                  --cs-theme-h4-after-l2-margin-top-mobile: 0.65em;
                  --cs-theme-h4-after-l2-margin-top-tablet-landscape: 0.65em;
                  --cs-theme-h4-after-l2-margin-top-desktop: 0.65em;
                  --cs-theme-h5-font-weight: var(--cs-theme-header-font-weight-normal);
                  --cs-theme-h5-font-size-mobile: 20px;
                  --cs-theme-h5-font-size-tablet-landscape: 24px;
                  --cs-theme-h5-font-size-desktop: 24px;
                  --cs-theme-h5-letter-spacing: -0.025em;
                  --cs-theme-h5-letter-spacing-mobile: -0.025em;
                  --cs-theme-h5-letter-spacing-tablet-landscape: -0.025em;
                  --cs-theme-h5-letter-spacing-desktop: -0.025em;
                  --cs-theme-h5-line-height-mobile: var(--cs-theme-header-line-height-mobile);
                  --cs-theme-h5-line-height-tablet-landscape: var(
                    --cs-theme-header-line-height-tablet
                  );
                  --cs-theme-h5-line-height-desktop: var(--cs-theme-header-line-height-desktop);
                  --cs-theme-h5-margin-mobile: 0.65em 0;
                  --cs-theme-h5-margin-tablet-portrait: 0.65em 0;
                  --cs-theme-h5-margin-tablet-landscape: 0.65em 0;
                  --cs-theme-h5-margin-desktop: 0.65em 0;
                  --cs-theme-h5-after-l2-margin-top-mobile: 0.25em;
                  --cs-theme-h5-after-l2-margin-top-tablet-landscape: 0.25em;
                  --cs-theme-h5-after-l2-margin-top-desktop: 0.25em;
                  --cs-theme-h6-font-weight: var(--cs-theme-header-font-weight-normal);
                  --cs-theme-h6-font-size-mobile: 20px;
                  --cs-theme-h6-font-size-desktop: 24px;
                  --cs-theme-h6-letter-spacing: var(--cs-theme-header-letter-spacing);
                  --cs-theme-h6-letter-spacing-mobile: var(--cs-theme-header-letter-spacing);
                  --cs-theme-h6-letter-spacing-desktop: var(--cs-theme-header-letter-spacing);
                  --cs-theme-h6-line-height-mobile: var(--cs-theme-header-line-height-mobile);
                  --cs-theme-h6-line-height-desktop: var(--cs-theme-header-line-height-desktop);
                  --cs-theme-h6-margin-mobile: 0.65em 0;
                  --cs-theme-h6-margin-tablet-portrait: 0.65em 0;
                  --cs-theme-h6-margin-tablet-landscape: 0.65em 0;
                  --cs-theme-h6-margin-desktop: 0.65em 0;
                  --cs-theme-h6-after-d3-margin-top-mobile: 0.65em;
                  --cs-theme-h6-after-d3-margin-top-tablet-landscape: 0.65em;
                  --cs-theme-h6-after-d3-margin-top-desktop: 0.65em;
                  --cs-theme-h6-after-l2-margin-top-mobile: 0.25em;
                  --cs-theme-ol-and-ul-padding-left-mobile: 0;
                  --cs-theme-nested-ol-and-ul-padding-left-mobile: 15px;
                  --cs-theme-nested-ol-and-ul-padding-left-tablet-landscape: 35px;
                  --cs-theme-li-margin-mobile: 8px 0;
                  --cs-theme-li-margin-tablet-landscape: 10px 0;
                  --cs-theme-ul-li-bullet-character: "\\2022";
                  --cs-theme-ul-li-bullet-margin-right-mobile: 10px;
                  --cs-theme-ul-li-bullet-margin-right-tablet-landscape: 20px;
                  --cs-theme-ol-li-before-bullet-width: 25px;
                  --cs-theme-d1-font-style: var(--cs-theme-display-font-style);
                  --cs-theme-d1-font-size-mobile: 50px;
                  --cs-theme-d1-font-size-tablet-portrait: 52px;
                  --cs-theme-d1-font-size-tablet-landscape: 64px;
                  --cs-theme-d1-font-size-desktop: 80px;
                  --cs-theme-d1-font-weight: var(--cs-theme-display-font-weight);
                  --cs-theme-d1-letter-spacing: var(--cs-theme-display-letter-spacing);
                  --cs-theme-d1-letter-spacing-mobile: var(--cs-theme-display-letter-spacing);
                  --cs-theme-d1-letter-spacing-tablet-portrait: var(
                    --cs-theme-display-letter-spacing
                  );
                  --cs-theme-d1-letter-spacing-tablet-landscape: var(
                    --cs-theme-display-letter-spacing
                  );
                  --cs-theme-d1-letter-spacing-desktop: var(--cs-theme-display-letter-spacing);
                  --cs-theme-d1-line-height-mobile: var(--cs-theme-display-line-height);
                  --cs-theme-d1-line-height-tablet-portrait: var(
                    --cs-theme-display-line-height
                  );
                  --cs-theme-d1-line-height-tablet-landscape: var(
                    --cs-theme-display-line-height
                  );
                  --cs-theme-d1-line-height-desktop: var(--cs-theme-display-line-height);
                  --cs-theme-d1-after-h4-margin-top-mobile: 0;
                  --cs-theme-d1-after-h4-margin-top-tablet-portrait: 0;
                  --cs-theme-d1-after-h4-margin-top-desktop: 0;
                  --cs-theme-d1-after-l2-margin-top-mobile: 0.15em;
                  --cs-theme-d1-after-l2-margin-top-tablet-portrait: 0.15em;
                  --cs-theme-d1-after-l2-margin-top-tablet-landscape: 0.15em;
                  --cs-theme-d1-after-l2-margin-top-desktop: 0.15em;
                  --cs-theme-d2-font-style: var(--cs-theme-display-font-style);
                  --cs-theme-d2-font-size-mobile: 42px;
                  --cs-theme-d2-font-size-tablet-portrait: 46px;
                  --cs-theme-d2-font-size-tablet-landscape: 54px;
                  --cs-theme-d2-font-size-desktop: 68px;
                  --cs-theme-d2-font-weight: var(--cs-theme-display-font-weight);
                  --cs-theme-d2-letter-spacing: var(--cs-theme-display-letter-spacing);
                  --cs-theme-d2-letter-spacing-mobile: var(--cs-theme-display-letter-spacing);
                  --cs-theme-d2-letter-spacing-tablet-portrait: var(
                    --cs-theme-display-letter-spacing
                  );
                  --cs-theme-d2-letter-spacing-tablet-landscape: var(
                    --cs-theme-display-letter-spacing
                  );
                  --cs-theme-d2-letter-spacing-desktop: var(--cs-theme-display-letter-spacing);
                  --cs-theme-d2-line-height-mobile: var(--cs-theme-display-line-height);
                  --cs-theme-d2-line-height-tablet-portrait: var(
                    --cs-theme-display-line-height
                  );
                  --cs-theme-d2-line-height-tablet-landscape: var(
                    --cs-theme-display-line-height
                  );
                  --cs-theme-d2-line-height-desktop: var(--cs-theme-display-line-height);
                  --cs-theme-d2-after-h4-margin-top-mobile: 0.15em;
                  --cs-theme-d2-after-h4-margin-top-tablet-landscape: 0.15em;
                  --cs-theme-d2-after-h4-margin-top-desktop: 0.15em;
                  --cs-theme-d2-after-l2-margin-top-mobile: 0.25em;
                  --cs-theme-d2-after-l2-margin-top-tablet-landscape: 0.25em;
                  --cs-theme-d2-after-l2-margin-top-desktop: 0.25em;
                  --cs-theme-d3-font-style: var(--cs-theme-display-font-style);
                  --cs-theme-d3-font-weight: var(--cs-theme-display-font-weight);
                  --cs-theme-d3-font-size-mobile: 36px;
                  --cs-theme-d3-font-size-tablet-portrait: 38px;
                  --cs-theme-d3-font-size-tablet-landscape: 44px;
                  --cs-theme-d3-font-size-desktop: 54px;
                  --cs-theme-d3-letter-spacing: var(--cs-theme-display-letter-spacing);
                  --cs-theme-d3-letter-spacing-mobile: var(--cs-theme-display-letter-spacing);
                  --cs-theme-d3-letter-spacing-tablet-portrait: var(
                    --cs-theme-display-letter-spacing
                  );
                  --cs-theme-d3-letter-spacing-tablet-landscape: var(
                    --cs-theme-display-letter-spacing
                  );
                  --cs-theme-d3-letter-spacing-desktop: var(--cs-theme-display-letter-spacing);
                  --cs-theme-d3-line-height-mobile: var(--cs-theme-display-line-height);
                  --cs-theme-d3-line-height-tablet-portrait: var(
                    --cs-theme-display-line-height
                  );
                  --cs-theme-d3-line-height-tablet-landscape: var(
                    --cs-theme-display-line-height
                  );
                  --cs-theme-d3-line-height-desktop: var(--cs-theme-display-line-height);
                  --cs-theme-d3-after-h4-margin-top-mobile: 0.25em;
                  --cs-theme-d3-after-h4-margin-top-tablet-landscape: 0.25em;
                  --cs-theme-d3-after-h4-margin-top-desktop: 0.25em;
                  --cs-theme-d3-after-h6-margin-top-mobile: 0.25em;
                  --cs-theme-d3-after-h6-margin-top-tablet-landscape: 0.25em;
                  --cs-theme-d3-after-h6-margin-top-desktop: 0.25em;
                  --cs-theme-d3-after-l2-margin-top-mobile: 0.35em;
                  --cs-theme-d3-after-l2-margin-top-tablet-landscape: 0.35em;
                  --cs-theme-d3-after-l2-margin-top-desktop: 0.35em;
                  --cs-theme-d4-font-style: var(--cs-theme-display-font-style);
                  --cs-theme-d4-font-size-mobile: 32px;
                  --cs-theme-d4-font-size-tablet-portrait: 32px;
                  --cs-theme-d4-font-size-tablet-landscape: 40px;
                  --cs-theme-d4-font-size-desktop: 44px;
                  --cs-theme-d4-font-weight: var(--cs-theme-display-font-weight);
                  --cs-theme-d4-letter-spacing: var(--cs-theme-display-letter-spacing);
                  --cs-theme-d4-letter-spacing-mobile: var(--cs-theme-display-letter-spacing);
                  --cs-theme-d4-letter-spacing-tablet-landscape: var(
                    --cs-theme-display-letter-spacing
                  );
                  --cs-theme-d4-letter-spacing-desktop: var(--cs-theme-display-letter-spacing);
                  --cs-theme-d4-line-height-mobile: var(--cs-theme-display-line-height);
                  --cs-theme-d4-line-height-tablet-portrait: var(
                    --cs-theme-display-line-height
                  );
                  --cs-theme-d4-line-height-tablet-landscape: var(
                    --cs-theme-display-line-height
                  );
                  --cs-theme-d4-line-height-desktop: var(--cs-theme-display-line-height);
                  --cs-theme-d5-font-style: var(--cs-theme-display-font-style);
                  --cs-theme-d5-font-size-mobile: 22px;
                  --cs-theme-d5-font-size-desktop: 32px;
                  --cs-theme-d5-font-weight: var(--cs-theme-display-font-weight);
                  --cs-theme-d5-letter-spacing: var(--cs-theme-display-letter-spacing);
                  --cs-theme-d5-line-height: 100%;
                  --cs-theme-d6-font-size-mobile: 20px;
                  --cs-theme-d6-font-size-desktop: 24px;
                  --cs-theme-d6-font-style: var(--cs-theme-display-font-style);
                  --cs-theme-d6-font-weight: var(--cs-theme-display-font-weight);
                  --cs-theme-d6-letter-spacing: var(--cs-theme-display-letter-spacing);
                  --cs-theme-d6-line-height: 100%;
                  --cs-theme-d4-after-h4-margin-top-mobile: 0.25em;
                  --cs-theme-d4-after-h4-margin-top-tablet-portrait: 0.25em;
                  --cs-theme-d4-after-h4-margin-top-desktop: 0.25em;
                  --cs-theme-d4-after-l2-margin-top-mobile: 0.5em;
                  --cs-theme-d4-after-l2-margin-top-tablet-landscape: 0.5em;
                  --cs-theme-d4-after-l2-margin-top-desktop: 0.5em;
                  --cs-theme-b1-font-size-mobile: 20px;
                  --cs-theme-b1-font-size-tablet-portrait: var(--cs-theme-b1-font-size-mobile);
                  --cs-theme-b1-font-size-tablet-landscape: var(
                    --cs-theme-b1-font-size-tablet-portrait
                  );
                  --cs-theme-b1-font-size-desktop: 24px;
                  --cs-theme-b1-letter-spacing-mobile: var(--cs-theme-body-letter-spacing);
                  --cs-theme-b1-letter-spacing-tablet-portrait: var(
                    --cs-theme-body-letter-spacing
                  );
                  --cs-theme-b1-letter-spacing-tablet-landscape: var(
                    --cs-theme-body-letter-spacing
                  );
                  --cs-theme-b1-letter-spacing-desktop: var(--cs-theme-body-letter-spacing);
                  --cs-theme-b1-line-height-mobile: var(--cs-theme-body-line-height-mobile);
                  --cs-theme-b1-line-height-tablet-portrait: var(
                    --cs-theme-body-line-height-tablet-landscape
                  );
                  --cs-theme-b1-line-height-tablet-landscape: var(
                    --cs-theme-body-line-height-tablet-landscape
                  );
                  --cs-theme-b1-line-height-desktop: var(--cs-theme-body-line-height-desktop);
                  --cs-theme-b1-margin-mobile: 0.75em 0;
                  --cs-theme-b1-margin-tablet-portrait: 0.75em 0;
                  --cs-theme-b1-margin-tablet-landscape: 0.75em 0;
                  --cs-theme-b1-margin-desktop: 0.75em 0;
                  --cs-theme-b2-font-size-mobile: var(--cs-theme-body-font-size-mobile);
                  --cs-theme-b2-font-size-tablet-portrait: var(
                    --cs-theme-body-font-size-mobile
                  );
                  --cs-theme-b2-font-size-tablet-landscape: var(
                    --cs-theme-body-font-size-tablet-landscape
                  );
                  --cs-theme-b2-font-size-desktop: var(--cs-theme-body-font-size-desktop);
                  --cs-theme-b2-letter-spacing-mobile: var(--cs-theme-body-letter-spacing);
                  --cs-theme-b2-letter-spacing-tablet-portrait: var(
                    --cs-theme-body-letter-spacing
                  );
                  --cs-theme-b2-letter-spacing-tablet-landscape: var(
                    --cs-theme-body-letter-spacing
                  );
                  --cs-theme-b2-letter-spacing-desktop: var(--cs-theme-body-letter-spacing);
                  --cs-theme-b2-line-height-mobile: var(--cs-theme-body-line-height-mobile);
                  --cs-theme-b2-line-height-tablet-portrait: var(
                    --cs-theme-body-line-height-tablet-landscape
                  );
                  --cs-theme-b2-line-height-tablet-landscape: var(
                    --cs-theme-body-line-height-tablet-landscape
                  );
                  --cs-theme-b2-line-height-desktop: var(--cs-theme-body-line-height-desktop);
                  --cs-theme-b2-margin-mobile: 0.5em 0;
                  --cs-theme-b2-margin-tablet-portrait: 0.5em 0;
                  --cs-theme-b2-margin-tablet-landscape: 0.5em 0;
                  --cs-theme-b2-after-d1-margin-top-mobile: 0.5em;
                  --cs-theme-b2-after-d1-margin-top-tablet-portrait: 0.5em;
                  --cs-theme-b2-after-d1-margin-top-tablet-landscape: 0.5em;
                  --cs-theme-b2-after-d1-margin-top-desktop: 0.5em;
                  --cs-theme-b2-after-d2-margin-top-mobile: 0.5em;
                  --cs-theme-b2-after-d2-margin-top-tablet-portrait: 0.5em;
                  --cs-theme-b2-after-d2-margin-top-desktop: 0.5em;
                  --cs-theme-b2-after-d3-margin-top-mobile: 0.5em;
                  --cs-theme-b2-after-d3-margin-top-tablet-portrait: 0.5em;
                  --cs-theme-b2-after-d3-margin-top-desktop: 0.5em;
                  --cs-theme-b2-after-d4-margin-top-mobile: 0.5em;
                  --cs-theme-b2-after-d4-margin-top-tablet-landscape: 0.5em;
                  --cs-theme-b2-after-d4-margin-top-desktop: 0.5em;
                  --cs-theme-b2-after-h2-margin-top-mobile: 0.5em;
                  --cs-theme-b2-after-h2-margin-top-tablet-landscape: 0.75em;
                  --cs-theme-b2-after-h2-margin-top-desktop: 0.75em;
                  --cs-theme-b2-after-h4-margin-top-mobile: 0.5em;
                  --cs-theme-b2-after-h4-margin-top-tablet-landscape: 0.75em;
                  --cs-theme-b2-after-h4-margin-top-desktop: 0.75em;
                  --cs-theme-b2-after-h5-margin-top-mobile: 0.35em;
                  --cs-theme-b2-after-h5-margin-top-tablet-landscape: 0.35em;
                  --cs-theme-b2-after-h5-margin-top-desktop: 0.35em;
                  --cs-theme-b2-after-h6-margin-top-mobile: 0.35em;
                  --cs-theme-b2-after-h6-margin-top-desktop: 0.35em;
                  --cs-theme-b2-after-b2-margin-top-mobile: 0;
                  --cs-theme-b2-after-b2-margin-top-desktop: 0;
                  --cs-theme-b2-after-b3-margin-top-mobile: 0.5em;
                  --cs-theme-b2-after-b3-margin-top-desktop: 0.5em;
                  --cs-theme-b2-after-l2-margin-top-mobile: 1em;
                  --cs-theme-b2-after-l2-margin-top-tablet-landscape: 1em;
                  --cs-theme-b2-after-l2-margin-top-desktop: 1em;
                  --cs-theme-b3-font-size-mobile: 14px;
                  --cs-theme-b3-font-size-desktop: 16px;
                  --cs-theme-b3-letter-spacing-mobile: var(--cs-theme-body-letter-spacing);
                  --cs-theme-b3-letter-spacing-tablet-portrait: var(
                    --cs-theme-body-letter-spacing
                  );
                  --cs-theme-b3-letter-spacing-desktop: var(--cs-theme-body-letter-spacing);
                  --cs-theme-b3-line-height-mobile: var(--cs-theme-body-line-height-mobile);
                  --cs-theme-b3-line-height-desktop: var(--cs-theme-body-line-height-desktop);
                  --cs-theme-b3-margin-mobile: 1em 0;
                  --cs-theme-b3-margin-desktop: 1em 0;
                  --cs-theme-b3-after-d4-margin-top-mobile: 0.75em;
                  --cs-theme-b3-after-d4-margin-top-desktop: 0.75em;
                  --cs-theme-b3-after-h5-margin-top-mobile: 0.65em;
                  --cs-theme-b3-after-h5-margin-top-tablet-landscape: 0.65em;
                  --cs-theme-b3-after-h5-margin-top-desktop: 0.65em;
                  --cs-theme-b3-after-h6-margin-top-mobile: 0.65em;
                  --cs-theme-b3-after-h6-margin-top-desktop: 0.65em;
                  --cs-theme-b3-after-b2-margin-top-mobile: 0.5em;
                  --cs-theme-b3-after-b2-margin-top-tablet-landscape: 0.5em;
                  --cs-theme-b3-after-b2-margin-top-desktop: 0.5em;
                  --cs-theme-l1-font-size-mobile: 24px;
                  --cs-theme-l1-font-size-tablet-landscape: var(--cs-theme-l1-font-size-mobile);
                  --cs-theme-l1-font-size-desktop: 26px;
                  --cs-theme-l1-font-weight: var(--cs-theme-label-font-weight);
                  --cs-theme-l1-letter-spacing: var(--cs-theme-label-letter-spacing);
                  --cs-theme-l1-line-height-mobile: var(--cs-theme-label-line-height-mobile);
                  --cs-theme-l1-line-height-tablet-landscape: var(
                    --cs-theme-label-line-height-tablet
                  );
                  --cs-theme-l1-line-height-desktop: var(--cs-theme-label-line-height-desktop);
                  --cs-theme-l1-margin-mobile: 1em 0;
                  --cs-theme-l1-margin-tablet-landscape: 1em 0;
                  --cs-theme-l1-margin-desktop: 1em 0;
                  --cs-theme-l2-font-size-mobile: 14px;
                  --cs-theme-l2-font-size-tablet-landscape: var(--cs-theme-l2-font-size-mobile);
                  --cs-theme-l2-font-size-desktop: 16px;
                  --cs-theme-l2-font-weight: var(--cs-theme-label-font-weight);
                  --cs-theme-l2-line-height-mobile: var(--cs-theme-label-line-height-mobile);
                  --cs-theme-l2-line-height-tablet-landscape: var(
                    --cs-theme-label-line-height-tablet
                  );
                  --cs-theme-l2-line-height-desktop: var(--cs-theme-label-line-height-desktop);
                  --cs-theme-l2-margin-mobile: 1.5em 0;
                  --cs-theme-l2-margin-tablet-landscape: 1.5em 0;
                  --cs-theme-l2-margin-desktop: 1.5em 0;
                  --cs-theme-l3-font-size-mobile: 14px;
                  --cs-theme-l3-font-size-desktop: 16px;
                  --cs-theme-l3-font-style: normal;
                  --cs-theme-l3-font-weight: var(--cs-theme-label-font-weight);
                  --cs-theme-l3-letter-spacing: var(--cs-theme-label-letter-spacing);
                  --cs-theme-l3-line-height: 100%;
                  --cs-theme-l4-font-size-mobile: 14px;
                  --cs-theme-l4-font-size-desktop: 14px;
                  --cs-theme-l4-font-style: normal;
                  --cs-theme-l4-font-weight: var(--cs-theme-label-font-weight);
                  --cs-theme-l4-letter-spacing: var(--cs-theme-label-letter-spacing);
                  --cs-theme-l4-line-height: 100%;
                  --cs-theme-input-standard-rounded-border-radius: 35px;
                  --cs-theme-date-field-standard-rounded-border-radius: 35px;
                  --cs-theme-countdown-clock-digit-font-family: var(
                    --cs-theme-secondary-font-family
                  );
                  --cs-theme-countdown-clock-digit-font-size: 140px;
                  --cs-theme-countdown-clock-digit-text-anchor: middle;
                  --cs-theme-countdown-clock-units-font-family: var(
                    --cs-theme-primary-font-family
                  );
                  --cs-theme-countdown-clock-units-font-size: 24px;
                  --cs-theme-countdown-clock-units-text-anchor: middle;
                  --cs-theme-countdown-clock-units-text-transform: var(
                    --cs-text-case,
                    uppercase
                  );
                  --cs-theme-local-nav-font-color-light: var(--cs-light-color);
                  --cs-theme-local-nav-font-color-dark: var(--cs-dark-color);
                  --cs-theme-local-nav-font-color-hover: var(--cs-theme-secondary-color);
                  --cs-theme-local-nav-shelf-header-font-size-mobile: var(
                    --cs-theme-body-font-size-mobile
                  );
                  --cs-theme-local-nav-shelf-header-font-size-tablet-landscape: var(
                    --cs-theme-body-font-size-tablet-landscape
                  );
                  --cs-theme-local-nav-shelf-header-font-size-desktop: var(
                    --cs-theme-body-font-size-desktop
                  );
                  --cs-theme-local-nav-shelf-header-letter-spacing-mobile: var(
                    --cs-theme-body-letter-spacing-mobile
                  );
                  --cs-theme-local-nav-shelf-header-letter-spacing-tablet-landscape: var(
                    --cs-theme-body-letter-spacing-tablet-landscape
                  );
                  --cs-theme-local-nav-shelf-header-letter-spacing-desktop: var(
                    --cs-theme-body-letter-spacing-desktop
                  );
                  --cs-theme-local-nav-shelf-header-font-family: var(
                    --cs-theme-secondary-font-family
                  );
                  --cs-theme-local-nav-shelf-link-current-dark-color: #585858;
                  --cs-theme-local-nav-shelf-link-current-light-color: #a3a3a3;
                  --cs-theme-local-nav-shelf-link-current-hover-dark-color: var(
                    --cs-dark-color
                  );
                  --cs-theme-local-nav-shelf-link-current-hover-light-color: var(
                    --cs-light-color
                  );
                  --cs-theme-local-nav-shelf-featured-link-current-dark-color: #585858;
                  --cs-theme-local-nav-shelf-featured-link-current-light-color: #a3a3a3;
                  --cs-theme-local-nav-shelf-featured-link-current-hover-dark-color: var(
                    --cs-dark-color
                  );
                  --cs-theme-local-nav-shelf-featured-link-current-hover-light-color: var(
                    --cs-light-color
                  );
                  --cs-theme-local-nav-shelf-font-family: var(--cs-theme-primary-font-family);
                  --cs-theme-local-nav-shelf-sub-nav-font-family: var(
                    --cs-theme-primary-font-family
                  );
                  --cs-theme-local-nav-shelf-sub-nav-section-font-size-mobile: 16px;
                  --cs-theme-local-nav-shelf-sub-nav-section-font-size-tablet-landscape: 16px;
                  --cs-theme-local-nav-shelf-sub-nav-section-font-size-desktop: 16px;
                  --cs-theme-local-nav-shelf-sub-nav-section-title-font-color-light: var(
                    --cs-light-color
                  );
                  --cs-theme-local-nav-shelf-sub-nav-section-title-font-color-dark: var(
                    --cs-dark-color
                  );
                  --cs-theme-local-nav-shelf-sub-nav-link-font-size-mobile: 16px;
                  --cs-theme-local-nav-shelf-sub-nav-link-font-size-tablet-landscape: 16px;
                  --cs-theme-local-nav-shelf-sub-nav-link-font-size-desktop: 16px;
                  --cs-theme-local-nav-drawer-link-current-dark-color: #585858;
                  --cs-theme-local-nav-drawer-link-current-light-color: #a3a3a3;
                  --cs-theme-local-nav-drawer-link-current-hover-dark-color: var(
                    --cs-dark-color
                  );
                  --cs-theme-local-nav-drawer-link-current-hover-light-color: var(
                    --cs-light-color
                  );
                  --cs-theme-local-nav-font-color-mobile-light: #a3a3a3;
                  --cs-theme-local-nav-font-color-mobile-dark: #161616;
                  --cs-theme-local-nav-nav-bar-color-mobile-light: #161616;
                  --cs-theme-local-nav-nav-bar-color-mobile-dark: #fff;
                  --cs-theme-local-nav-menu-bar-color-mobile-light: #222;
                  --cs-theme-local-nav-menu-bar-color-mobile-dark: #f3f3f3;
                  --cs-theme-local-nav-close-button-color-mobile-light: #f3f3f3;
                  --cs-theme-local-nav-close-button-color-mobile-dark: #161616;
                  --cs-theme-local-nav-category-open-color-mobile-light: #a3a3a3;
                  --cs-theme-local-nav-category-open-color-mobile-dark: #a3a3a3;
                  --cs-theme-local-nav-category-close-color-mobile-light: #fff;
                  --cs-theme-local-nav-category-close-color-mobile-dark: #252525;
                  --cs-theme-local-nav-link-selected-color-mobile-light: var(--cs-theme-color);
                  --cs-theme-local-nav-link-selected-color-mobile-dark: var(--cs-theme-color);
                  --cs-theme-local-nav-link-unselected-color-mobile-light: #f3f3f3;
                  --cs-theme-local-nav-link-unselected-color-mobile-dark: #252525;
                  --cs-theme-local-nav-link-divider-unselected-color-mobile-light: #a3a3a3;
                  --cs-theme-local-nav-link-divider-unselected-color-mobile-dark: #252525;
                  --cs-theme-local-nav-category-selected-color-mobile-light: #fff;
                  --cs-theme-local-nav-category-selected-color-mobile-dark: #252525;
                  --cs-theme-local-nav-category-unselected-color-mobile-light: #a3a3a3;
                  --cs-theme-local-nav-category-unselected-color-mobile-dark: #a3a3a3;
                  --cs-theme-local-nav-category-divider-color-mobile-light: #fff;
                  --cs-theme-local-nav-category-divider-color-mobile-dark: #252525;
                  --cs-theme-local-nav-category-divider-unselected-color-mobile-light: #c4c4c4;
                  --cs-theme-local-nav-category-divider-unselected-color-mobile-dark: #a3a3a3;
                  --cs-theme-local-nav-sub-link-color-mobile-light: #fff;
                  --cs-theme-local-nav-sub-link-color-mobile-dark: #252525;
                  --cs-theme-local-nav-hover-color-mobile: var(--cs-theme-color);
                  --cs-theme-local-nav-current-link-color-mobile-light: var(--cs-theme-color);
                  --cs-theme-local-nav-current-link-color-mobile-dark: var(--cs-theme-color);
                  --cs-theme-local-nav-current-link-color-mobile-hover-light: var(
                    --cs-theme-color
                  );
                  --cs-theme-local-nav-current-link-color-mobile-hover-dark: var(
                    --cs-theme-color
                  );
                  --cs-theme-mobile-nav-link-font-size-mobile: 16px;
                  --cs-theme-mobile-nav-category-font-size-mobile: 16px;
                  --cs-theme-mobile-nav-sub-link-font-size-mobile: 14px;
                  --cs-theme-mobile-nav-cta-dropdown-font-size-mobile: 14px;
                  --cs-theme-mobile-nav-cta-font-size-mobile: 16px;
                  --cs-theme-mobile-nav-title-font-size-mobile: 20px;
                  --cs-theme-local-nav-drawer-header-font-family: var(
                    --cs-theme-local-nav-shelf-header-font-family
                  );
                  --cs-theme-local-nav-drawer-sub-nav-font-family: var(
                    --cs-theme-local-nav-shelf-sub-nav-font-family
                  );
                  --cs-theme-local-nav-drawer-font-family: var(
                    --cs-theme-local-nav-shelf-font-family
                  );
                  --cs-theme-local-nav-drawer-sub-link-current-dark-color: #585858;
                  --cs-theme-local-nav-drawer-sub-link-current-light-color: #a3a3a3;
                  --cs-theme-local-nav-drawer-sub-link-current-hover-dark-color: var(
                    --cs-dark-color
                  );
                  --cs-theme-local-nav-drawer-sub-link-current-hover-light-color: var(
                    --cs-light-color
                  );
                  --cs-theme-local-footer-font-color-dark: #161616;
                  --cs-theme-local-footer-font-color-light: #a3a3a3;
                  --cs-theme-dropdown-font-size-mobile: var(--cs-theme-body-font-size-mobile);
                  --cs-theme-dropdown-font-size-tablet-landscape: var(
                    --cs-theme-body-font-size-tablet-landscape
                  );
                  --cs-theme-dropdown-line-height-mobile: var(
                    --cs-theme-body-line-height-mobile
                  );
                  --cs-theme-dropdown-line-height-tablet-landscape: var(
                    --cs-theme-body-line-height-tablet-landscape
                  );
                  --cs-theme-dropdown-standard-rounded-border-radius: 35px;
                  --cs-theme-agegate-cover: var(--cs-dark-color);
                  --cs-theme-agegate-cover-icon: var(--cs-light-color);
                  --cs-theme-agegate-cover-icon-hover: var(--cs-theme-color);
                  --cs-theme-sub-nav-font-size-mobile: var(--cs-theme-body-font-size-mobile);
                  --cs-theme-sub-nav-font-size-tablet-portrait: var(
                    --cs-theme-body-font-size-mobile
                  );
                  --cs-theme-sub-nav-font-size-tablet-landscape: var(
                    --cs-theme-body-font-size-tablet-landscape
                  );
                  --cs-theme-sub-nav-font-size-desktop: var(--cs-theme-body-font-size-desktop);
                  --cs-theme-sub-nav-letter-spacing-mobile: var(
                    --cs-theme-body-letter-spacing-mobile
                  );
                  --cs-theme-sub-nav-letter-spacing-tablet-portrait: var(
                    --cs-theme-body-letter-spacing-mobile
                  );
                  --cs-theme-sub-nav-letter-spacing-tablet-landscape: var(
                    --cs-theme-body-letter-spacing-tablet-landscape
                  );
                  --cs-theme-sub-nav-letter-spacing-desktop: var(
                    --cs-theme-body-letter-spacing-desktop
                  );
                  --cs-theme-catalog-text-shadow: none;
                  --cs-theme-tile-text-shadow: var(--cs-theme-catalog-text-shadow);
                  --cs-theme-describe-text-shadow: none;
                  --cs-theme-header-text-shadow: var(--cs-theme-describe-text-shadow);
                  --cs-theme-subheading-text-shadow: var(--cs-theme-describe-text-shadow);
                  --cs-theme-promote-text-shadow: none;
                  --cs-theme-featured-content-text-shadow: var(--cs-theme-promote-text-shadow);
                  --cs-theme-hero-text-shadow: var(--cs-theme-promote-text-shadow);
                  --cs-theme-highlight-media-text-shadow: var(--cs-theme-promote-text-shadow);
                  --cs-theme-pitch-text-shadow: var(--cs-theme-promote-text-shadow);
                  --cs-theme-tout-text-shadow: var(--cs-theme-promote-text-shadow);
                  --cs-theme-tabs-background-color: #6801d7;
                  --cs-theme-tabs-indicator-color: #fe1d3b;
                  --cs-theme-tabs-interface-color: #fff;
                  --cs-theme-tabs-unselected-type: rgba(255, 255, 255, 0.5);
                  --cs-theme-tabs-selected-type: #fff;
                  --cs-theme-tabs-selected-state: rgba(255, 255, 255, 0.08);
                  --cs-theme-tabs-accent-elements: rgba(0, 0, 0, 0.08);
                  --cs-theme-tabs-inactive-interface-color: rgba(255, 255, 255, 0.1);
                  --cs-theme-tabs-tab-text-transform: capitalize;
                  --cs-theme-tabs-stage-gutter: 60px;
                  --cs-theme-spacer-height: 32px;
                  --cs-theme-spacer-height-mobile: 40px;
                  --cs-theme-spacer-height-tablet-portrait: 56px;
                  --cs-theme-spacer-height-tablet-landscape: 64px;
                  --cs-theme-spacer-height-desktop: 80px;
                  --cs-theme-toaster-eyebrow-font-size-mobile: var(
                    --cs-theme-l1-font-size-mobile
                  );
                  --cs-theme-toaster-eyebrow-font-size-tablet: var(
                    --cs-theme-l1-font-size-tablet-landscape
                  );
                  --cs-theme-toaster-eyebrow-font-size-desktop: var(
                    --cs-theme-l1-font-size-desktop
                  );
                  --cs-theme-toaster-copy-font-size-mobile: var(--cs-theme-b3-font-size-mobile);
                  --cs-theme-toaster-copy-font-size-tablet: var(
                    --cs-theme-b3-font-size-desktop
                  );
                  --cs-theme-toaster-copy-font-size-desktop: var(
                    --cs-theme-b3-font-size-desktop
                  );
                  --cs-theme-toaster-link-font-size-mobile: var(--cs-theme-b3-font-size-mobile);
                  --cs-theme-toaster-link-font-size-tablet: var(
                    --cs-theme-b3-font-size-desktop
                  );
                  --cs-theme-toaster-link-font-size-desktop: var(
                    --cs-theme-b3-font-size-desktop
                  );
                  --cs-theme-pagination-font-size-mobile: var(--cs-theme-l2-font-size-mobile);
                  --cs-theme-pagination-font-size-tablet-landscape: var(
                    --cs-theme-l2-font-size-tablet-landscape
                  );
                  --cs-theme-pagination-font-size-desktop: var(--cs-theme-l2-font-size-desktop);
                  --cs-theme-player-ratings-attribute-font-size-mobile: 12px;
                  --cs-theme-player-ratings-attribute-font-size-tablet-landscape: 14px;
                  --cs-theme-player-ratings-attribute-font-size-desktop: 20px;
                  --cs-theme-player-ratings-attributes-font-size-mobile: 12px;
                  --cs-theme-player-ratings-attributes-font-size-tablet-landscape: 16px;
                  --cs-theme-player-ratings-attributes-font-size-desktop: 16px;
                  --cs-theme-player-ratings-player-label-font-size-mobile: 16px;
                  --cs-theme-player-ratings-player-label-font-size-tablet-landscape: 16px;
                  --cs-theme-player-ratings-player-label-font-size-desktop: 16px;
                  --cs-theme-player-ratings-player-name-font-size-mobile: 12px;
                  --cs-theme-player-ratings-player-name-font-size-tablet-landscape: 14px;
                  --cs-theme-player-ratings-player-name-font-size-desktop: 16px;
                  --cs-theme-player-ratings-tooltip-font-size: 16px;
                  --cs-theme-player-ratings-value-font-size-mobile: 15px;
                  --cs-theme-player-ratings-value-font-size-tablet-landscape: 16px;
                  --cs-theme-player-ratings-value-font-size-desktop: 20px;
                  --cs-theme-player-ratings-card-labels-font-size-mobile: 12px;
                  --cs-theme-player-ratings-card-labels-font-size-tablet-landscape: 16px;
                  --cs-theme-player-ratings-card-labels-font-size-desktop: 16px;
                  --cs-theme-player-ratings-card-overallrating-count-font-size-tablet-portrait: 20px;
                  --cs-theme-player-ratings-card-overallrating-count-font-size-tablet-landscape: 20px;
                  --cs-theme-player-ratings-card-overallrating-count-font-size-desktop: 20px;
                  --cs-theme-player-ratings-card-overallrating-label-font-size-tablet-portrait: 14px;
                  --cs-theme-player-ratings-card-overallrating-label-font-size-tablet-landscape: 14px;
                  --cs-theme-player-ratings-card-overallrating-label-font-size-desktop: 16px;
                  --cs-theme-player-ratings-compare-player-name-font-size-mobile: 12px;
                  --cs-theme-player-ratings-compare-player-name-font-size-tablet-landscape: 20px;
                  --cs-theme-player-ratings-compare-player-name-font-size-desktop: 24px;
                  --cs-theme-player-ratings-compare-rating-title-font-size-mobile: 12px;
                  --cs-theme-player-ratings-compare-rating-title-font-size-tablet-landscape: 16px;
                  --cs-theme-player-ratings-compare-rating-title-font-size-desktop: 18px;
                  --cs-theme-player-ratings-compare-rating-value-font-size-mobile: 12px;
                  --cs-theme-player-ratings-compare-rating-value-font-size-tablet-landscape: 18px;
                  --cs-theme-player-ratings-compare-rating-value-font-size-desktop: 18px;
                  --cs-theme-player-ratings-compare-rating-value-first-font-size-mobile: 14px;
                  --cs-theme-player-ratings-compare-rating-value-first-font-size-tablet-landscape: 20px;
                  --cs-theme-player-ratings-compare-rating-value-first-font-size-desktop: 20px;
                  --cs-theme-player-ratings-compare-rating-value-first-font-size-xs: 11px;
                  --cs-theme-player-ratings-compare-dropdown-attributes-font-size-mobile: 16px;
                  --cs-theme-player-ratings-compare-dropdown-attributes-first-font-size-tablet-landscape: 16px;
                  --cs-theme-player-ratings-compare-dropdown-attributes-first-font-size-desktop: 16px;
                  --cs-theme-predictor-block-margin-top-mobile: 20px;
                  --cs-theme-predictor-block-margin-top-tablet-portrait: 30px;
                  --cs-theme-predictor-block-margin-top-tablet-landscape: 40px;
                  --cs-theme-predictor-block-margin-top-desktop: 48px;
                  --cs-theme-predictor-block-margin-bottom-mobile: 20px;
                  --cs-theme-predictor-block-margin-bottom-tablet-portrait: 30px;
                  --cs-theme-predictor-block-margin-bottom-tablet-landscape: 40px;
                  --cs-theme-predictor-block-margin-bottom-desktop: 48px;
                  --cs-theme-predictor-block-step-font-size-mobile: 14px;
                  --cs-theme-predictor-block-step-font-size-tablet: 14px;
                  --cs-theme-predictor-block-step-font-size-desktop: 16px;
                  --cs-theme-predictor-block-title-font-size-mobile: 20px;
                  --cs-theme-predictor-block-title-font-size-tablet: 20px;
                  --cs-theme-predictor-block-title-font-size-desktop: 24px;
                  --cs-theme-predictor-block-vs-font-size-mobile: 14px;
                  --cs-theme-predictor-block-vs-font-size-tablet: 14px;
                  --cs-theme-predictor-block-vs-font-size-desktop: 16px;
                  --cs-theme-predictor-block-player-primary-font-size-mobile: 20px;
                  --cs-theme-predictor-block-player-primary-font-size-tablet: 20px;
                  --cs-theme-predictor-block-player-primary-font-size-desktop: 24px;
                  --cs-theme-predictor-block-player-secondary-font-size-mobile: 14px;
                  --cs-theme-predictor-block-player-secondary-font-size-tablet: 14px;
                  --cs-theme-predictor-block-player-secondary-font-size-desktop: 16px;
                  --cs-theme-predictor-popup-heading-font-size-mobile: 30px;
                  --cs-theme-predictor-popup-heading-font-size-tablet: 32px;
                  --cs-theme-predictor-popup-heading-font-size-desktop: 40px;
                  --cs-theme-predictor-popup-body-font-size-mobile: 14px;
                  --cs-theme-predictor-popup-body-font-size-tablet: 14px;
                  --cs-theme-predictor-popup-body-font-size-desktop: 16px;
                  --cs-theme-predictor-popup-social-font-size-mobile: 18px;
                  --cs-theme-predictor-popup-social-font-size-tablet: 20px;
                  --cs-theme-predictor-popup-social-font-size-desktop: 24px;
                  --cs-theme-predictor-incomplete-message-font-size-mobile: 16px;
                  --cs-theme-predictor-incomplete-message-font-size-tablet: 20px;
                  --cs-theme-predictor-incomplete-message-font-size-desktop: 20px;
                  --cs-theme-predictor-alert-color: #f00;
                  --cs-theme-predictor-block-outcome-font-size-xs-mobile: 12px;
                  --cs-theme-predictor-block-outcome-font-size-mobile: 14px;
                  --cs-theme-predictor-block-outcome-font-size-tablet-landscape: 16px;
                  --cs-theme-predictor-block-outcome-font-size-desktop: 16px;
                  --cs-theme-predictor-score-font-size-mobile: 25px;
                  --cs-theme-predictor-score-font-size-tablet-landscape: 25px;
                  --cs-theme-predictor-score-font-size-desktop: 34px;
                  --cs-theme-predictor-block-player-primary-line-height-desktop: 120%;
                  --cs-theme-predictor-block-player-primary-line-height-mobile: 120%;
                  --cs-theme-predictor-block-player-secondary-line-height-desktop: 120%;
                  --cs-theme-predictor-block-player-secondary-line-height-mobile: 120%;
                  --cs-theme-predictor-score-number-font-family: var(
                    --cs-theme-secondary-font-family
                  );
                  --cs-theme-predictor-primary-font-family: "open-sans";
                  --cs-theme-predictor-success-cta-font-size-mobile: 15px;
                  --cs-theme-predictor-success-cta-font-size-tablet-landscape: 16px;
                  --cs-theme-predictor-success-cta-font-size-desktop: 20px;
                  --cs-theme-predictor-success-download-title-font-size-mobile: 18px;
                  --cs-theme-predictor-success-download-title-font-size-tablet-landscape: 20px;
                  --cs-theme-predictor-success-download-title-font-size-desktop: 24px;
                  --cs-theme-predictor-success-cta-line-height-mobile: 20px;
                  --cs-theme-predictor-success-cta-line-height-tablet-landscape: 20px;
                  --cs-theme-predictor-success-cta-line-height-desktop: 20px;
                  --cs-theme-player-ratings-card-f1-theme-color: #cb0503;
                  --cs-theme-player-ratings-card-f1-labels-font-size: 16px;
                  --cs-theme-predictor-award-body-font-size-mobile: 14px;
                  --cs-theme-predictor-award-body-font-size-tablet-landscape: 16px;
                  --cs-theme-predictor-award-body-font-size-desktop: 16px;
                  --cs-theme-predictor-award-remove-fill-color: #fff;
                  --cs-theme-predictor-award-remove-stroke-color: #000;
                  --cs-theme-predictor-award-stream-ui-paddle-default: #333;
                  --cs-theme-predictor-award-stream-ui-paddle-disabled: #bfbfbf;
                  --cs-theme-predictor-award-stream-ui-paddle-fill-color: #fff;
                  --cs-theme-predictor-award-stream-ui-paddle-fill-disabled: #fff;
                  --cs-theme-predictor-award-title-font-family: "DIN-condensed", "oswald";
                  --cs-theme-predictor-award-body-font-family: "seravek-web", "open-sans";
                  --cs-theme-predictor-award-title-font-size-mobile: 15px;
                  --cs-theme-predictor-award-title-font-size-tablet-landscape: 21px;
                  --cs-theme-predictor-award-title-font-size-desktop: 21px;
                  --cs-theme-predictor-award-selection-animation-duration: 800ms;
                  --cs-theme-predictor-award-selection-slide-from-value: 70px;
                  --cs-theme-predictor-award-selection-slide-to-value: 0;
                  --cs-theme-predictor-award-gallery-slide-from-value: 0;
                  --cs-theme-predictor-award-gallery-slide-to-value: -40px;
                  --cs-theme-predictor-award-tab-arrow-color: #333;
                  --cs-theme-predictor-award-tab-bar-color: #c4c4c4;
                  --cs-theme-predictor-award-tab-disabled-color: #bfbfbf;
                  --cs-theme-predictor-award-tab-font-family: "DIN-condensed";
                  --cs-theme-predictor-award-tab-font-size-small-mobile: 12px;
                  --cs-theme-predictor-award-tab-font-size-mobile: 18px;
                  --cs-theme-predictor-award-tab-font-size-tablet-landscape: 18px;
                  --cs-theme-predictor-award-tab-font-size-desktop: 18px;
                  --cs-theme-predictor-award-tab-selected-color: #ff1e3c;
                  --cs-theme-predictor-award-tab-unselected-color: #7c7c7c;
                  --cs-theme-predictor-award-tab-hover-color: #ff1e3c;
                  --cs-theme-predictor-award-divider-tabs-color: #e4e4e4;
                  --cs-theme-predictor-award-pages-slide-up-duration: 600ms;
                  --cs-theme-predictor-award-pages-slide-down-duration: 200ms;
                  --cs-theme-predictor-award-pages-slide-up-from-value: 40px;
                  --cs-theme-predictor-award-pages-slide-up-to-value: 0;
                  --cs-theme-predictor-award-pages-slide-down-from-value: 0;
                  --cs-theme-predictor-award-pages-slide-down-to-value: 40px;
                  --cs-theme-predictor-popup-results-font-size-mobile: 12px;
                  --cs-theme-predictor-popup-results-font-size-tablet: 14px;
                  --cs-theme-predictor-popup-results-font-size-desktop: 14px;
                  --cs-theme-predictor-results-votes-font-size-mobile: 12px;
                  --cs-theme-predictor-results-votes-font-size-tablet: 15px;
                  --cs-theme-predictor-results-votes-font-size-desktop: 17px;
                  --cs-theme-predictor-results-divider-color-dark: #c4c4c4;
                  --cs-theme-predictor-results-divider-color-light: #3e3e3e;
                  --cs-theme-predictor-results-winning-team-name-font-size-mobile: 20px;
                  --cs-theme-predictor-results-winning-team-name-font-size-tablet: 22px;
                  --cs-theme-predictor-results-winning-team-name-font-size-desktop: 22px;
                  --cs-theme-predictor-results-winning-team-body-copy-font-size-mobile: 14px;
                  --cs-theme-predictor-results-winning-team-body-copy-font-size-tablet: 14px;
                  --cs-theme-predictor-results-winning-team-body-copy-font-size-desktop: 15px;
                  --cs-theme-predictor-results-party-name-font-size-mobile: 15px;
                  --cs-theme-predictor-results-party-name-font-size-tablet: 17px;
                  --cs-theme-predictor-results-party-name-font-size-desktop: 20px;
                  --cs-theme-predictor-results-pie-chart-text-font-size-mobile: 15px;
                  --cs-theme-predictor-results-pie-chart-text-font-size-tablet: 12px;
                  --cs-theme-predictor-results-pie-chart-text-font-size-desktop: 15px;
                  --cs-theme-predictor-results-score-font-size-mobile: 15px;
                  --cs-theme-predictor-results-score-font-size-tablet: 20px;
                  --cs-theme-predictor-results-score-font-size-desktop: 26px;
                  --cs-theme-predictor-results-awards-team-member-name-font-size-mobile: 15px;
                  --cs-theme-predictor-results-awards-team-member-name-font-size-tablet: 17px;
                  --cs-theme-predictor-results-awards-team-member-name-font-size-desktop: 20px;
                  --cs-theme-predictor-results-awards-team-member-body-font-size-mobile: 12px;
                  --cs-theme-predictor-results-awards-team-member-body-font-size-tablet: 14px;
                  --cs-theme-predictor-results-awards-team-member-body-font-size-desktop: 16px;
                  --cs-theme-predictor-results-awards-team-member-party-name-font-size-mobile: 12px;
                  --cs-theme-predictor-results-awards-team-member-party-name-font-size-tablet: 14px;
                  --cs-theme-predictor-results-awards-team-member-party-name-font-size-desktop: 16px;
                  --cs-theme-predictor-results-awards-percentage-font-size-mobile: 13px;
                  --cs-theme-predictor-results-awards-percentage-font-size-tablet: 13px;
                  --cs-theme-predictor-results-awards-percentage-font-size-desktop: 21px;
                  --cs-theme-player-ratings-fifa-compare-rating-title-font-size-mobile: 11px;
                  --cs-theme-player-ratings-fifa-compare-rating-title-font-size-tablet-landscape: 16px;
                  --cs-theme-player-ratings-fifa-compare-rating-title-font-size-desktop: 18px;
                  --cs-theme-player-ratings-skill-label-font-size-mobile: 14px;
                  --cs-theme-player-ratings-skill-label-font-size-tablet-landscape: 14px;
                  --cs-theme-player-ratings-skill-label-font-size-desktop: 14px;
                  --cs-theme-player-ratings-low-bar-color: #ea3323;
                  --cs-theme-player-ratings-mid-bar-color: #eac444;
                  --cs-theme-player-ratings-high-bar-color: #5ebb46;
                  --cs-theme-player-ratings-f1-compare-rating-title-font-size-mobile: 12px;
                  --cs-theme-player-ratings-f1-compare-rating-title-font-size-tablet-landscape: 16px;
                  --cs-theme-player-ratings-f1-compare-rating-title-font-size-desktop: 18px;
                  --cs-theme-player-ratings-f1-detail-border-color-dark: #e2e2e2;
                  --cs-theme-player-ratings-f1-detail-border-color-light: #5f5f65;
                  --cs-theme-player-ratings-f1-detail-background-color-dark: #f6f6f6;
                  --cs-theme-player-ratings-f1-detail-background-color-light: #18191b;
                  --cs-theme-player-ratings-mcs-compare-rating-title-font-size-mobile: 12px;
                  --cs-theme-player-ratings-mcs-compare-rating-title-font-size-tablet-landscape: 16px;
                  --cs-theme-player-ratings-mcs-compare-rating-title-font-size-desktop: 18px;
                  --cs-theme-player-ratings-mcs-detail-border-color-dark: #e2e2e2;
                  --cs-theme-player-ratings-mcs-detail-border-color-light: #5f5f65;
                  --cs-theme-player-ratings-mcs-detail-background-color-dark: #f6f6f6;
                  --cs-theme-player-ratings-mcs-detail-background-color-light: #18191b;
                  --cs-theme-map-panel-background-color: var(--cs-light-color);
                  --cs-theme-map-panel-close-color: var(--cs-theme-color);
                  --cs-theme-map-panel-footer-background-color: var(--cs-dark-color);
                  --cs-theme-map-panel-paddle-text-color: var(--cs-theme-color);
                  --cs-theme-eacom-progress-bar-marker-font-size-mobile: 12px;
                  --cs-theme-eacom-progress-bar-marker-font-size-tablet-landscape: 12px;
                  --cs-theme-eacom-progress-bar-marker-font-size-desktop: 12px;
                  --cs-theme-eacom-progress-bar-circle-label-font-size-mobile: 14px;
                  --cs-theme-eacom-progress-bar-circle-label-font-size-tablet-landscape: 16px;
                  --cs-theme-eacom-progress-bar-circle-label-font-size-desktop: 18px;
                  --cs-theme-match-score-team-name-font-size-mobile: 16px;
                  --cs-theme-match-score-team-name-font-size-tablet-landscape: 20px;
                  --cs-theme-match-score-team-name-font-size-desktop: 22px;
                  --cs-theme-pro-clubs-report-label-font-size-mobile: 16px;
                  --cs-theme-pro-clubs-report-label-font-size-tablet-landscape: 16px;
                  --cs-theme-pro-clubs-report-label-font-size-desktop: 20px;
                  --cs-theme-pro-clubs-report-overlay-font-size-mobile: 14px;
                  --cs-theme-pro-clubs-report-overlay-font-size-tablet-landscape: 14px;
                  --cs-theme-pro-clubs-report-overlay-font-size-desktop: 14px;
                  --cs-theme-pro-clubs-report-column-title-font-weight: 700;
                  --cs-theme-pro-clubs-member-name-font-size: 21px;
                  --cs-theme-proclub-overview-font-size-mobile: 12px;
                  --cs-theme-proclub-overview-font-size-tablet: 18px;
                  --cs-theme-proclub-overview-font-size-desktop: 16px;
                  --cs-theme-proclub-overview-font-size-xl-desktop: 18px;
                  --cs-theme-proclub-selected-patform-cta-color: var(--cs-theme-color);
                  --cs-theme-pro-clubs-achievements-finish-font-size-mobile: 18px;
                  --cs-theme-pro-clubs-achievements-finish-font-size-tablet-landscape: 18px;
                  --cs-theme-pro-clubs-achievements-finish-font-size-desktop: 16px;
                  --cs-theme-pro-clubs-achievements-season-font-size-mobile: 20px;
                  --cs-theme-pro-clubs-achievements-season-font-size-tablet-landscape: 20px;
                  --cs-theme-pro-clubs-achievements-season-font-size-desktop: 24px;
                  --cs-theme-pro-clubs-header-region-font-size-mobile: 20px;
                  --cs-theme-pro-clubs-header-region-font-size-tablet-landscape: 20px;
                  --cs-theme-pro-clubs-header-region-font-size-desktop: 20px;
                  --cs-theme-pro-clubs-header-club-name-font-size-mobile: 36px;
                  --cs-theme-pro-clubs-header-club-name-font-size-tablet-landscape: 44px;
                  --cs-theme-pro-clubs-header-club-name-font-size-desktop: 54px;
                  --cs-theme-pro-clubs-header-skill-rating-font-size-mobile: 17px;
                  --cs-theme-pro-clubs-header-skill-rating-font-size-tablet-landscape: 18px;
                  --cs-theme-pro-clubs-header-skill-rating-font-size-desktop: 18px;
                  --cs-theme-pro-clubs-header-skill-rating-number-font-size-mobile: 26px;
                  --cs-theme-pro-clubs-header-skill-rating-number-font-size-tablet-landscape: 36px;
                  --cs-theme-pro-clubs-header-skill-rating-number-font-size-desktop: 36px;
                  --cs-theme-pro-clubs-header-reputation-font-size-mobile: 18px;
                  --cs-theme-pro-clubs-header-reputation-font-size-tablet-landscape: 20px;
                  --cs-theme-pro-clubs-header-reputation-font-size-desktop: 20px;
                  --cs-theme-team-builder-primary-font-family: "open-sans";
                  --cs-theme-team-builder-secondary-font-family: "DIN-condensed";
                  --cs-theme-team-builder-tab-bar-color: #c4c4c4;
                  --cs-theme-team-builder-divider-tabs-color: #e4e4e4;
                  --cs-theme-team-builder-tab-selected-color: #ff1e3c;
                  --cs-theme-team-builder-tab-unselected-color: #7c7c7c;
                  --cs-theme-team-builder-tab-hover-color: #ff1e3c;
                  --cs-theme-team-builder-divider-carousel-color: #e4e4e4;
                  --cs-theme-team-builder-pitch-remove-fill-color: #fff;
                  --cs-theme-team-builder-pitch-remove-stroke-color: #000;
                  --cs-theme-team-builder-stream-ui-paddle-default: #333;
                  --cs-theme-team-builder-stream-ui-paddle-disabled: #bfbfbf;
                  --cs-theme-team-builder-stream-ui-paddle-fill-color: #fff;
                  --cs-theme-team-builder-stream-ui-paddle-fill-disabled: #fff;
                  --cs-theme-team-builder-tab-arrow-color: #333;
                  --cs-theme-team-builder-tab-disabled-color: #bfbfbf;
                  --cs-theme-team-builder-terms-conditions-font-color: var(--cs-theme-color);
                  --cs-theme-team-builder-submit-color: #fafa20;
                  --cs-theme-team-builder-submit-disabled-color: #c2c2c2;
                  --cs-theme-team-builder-title-font-size-mobile: 32px;
                  --cs-theme-team-builder-title-font-size-tablet-landscape: 32px;
                  --cs-theme-team-builder-title-font-size-desktop: 32px;
                  --cs-theme-team-builder-body-font-size-mobile: 14px;
                  --cs-theme-team-builder-body-font-size-tablet-landscape: 14px;
                  --cs-theme-team-builder-body-font-size-desktop: 16px;
                  --cs-theme-team-builder-block-margin-top-mobile: 30px;
                  --cs-theme-team-builder-block-margin-top-tablet: 48px;
                  --cs-theme-team-builder-tabs-font-size-small-mobile: 12px;
                  --cs-theme-team-builder-tabs-font-size-mobile: 18px;
                  --cs-theme-team-builder-tabs-font-size-tablet-landscape: 18px;
                  --cs-theme-team-builder-tabs-font-size-desktop: 18px;
                  --cs-theme-team-builder-terms-font-size-mobile: 14px;
                  --cs-theme-team-builder-terms-font-size-tablet-landscape: 14px;
                  --cs-theme-team-builder-terms-font-size-desktop: 16px;
                  --cs-theme-team-builder-popup-heading-font-size-mobile: 30px;
                  --cs-theme-team-builder-popup-heading-font-size-tablet-landscape: 32px;
                  --cs-theme-team-builder-popup-heading-font-size-desktop: 44px;
                  --cs-theme-team-builder-popup-body-font-size-mobile: 14px;
                  --cs-theme-team-builder-popup-body-font-size-tablet-landscape: 14px;
                  --cs-theme-team-builder-popup-body-font-size-desktop: 16px;
                  --cs-theme-team-builder-popup-social-size-mobile: 18px;
                  --cs-theme-team-builder-popup-social-font-size-tablet-landscape: 20px;
                  --cs-theme-team-builder-popup-social-font-size-desktop: 24px;
                  --cs-theme-team-builder-popup-success-cta-font-size-mobile: 15px;
                  --cs-theme-team-builder-popup-success-cta-font-size-tablet-landscape: 16px;
                  --cs-theme-team-builder-popup-success-cta-font-size-desktop: 20px;
                  --cs-theme-team-builder-popup-success-cta-line-height-mobile: 20px;
                  --cs-theme-team-builder-popup-success-cta-line-height-tablet-landscape: 20px;
                  --cs-theme-team-builder-popup-success-cta-line-height-desktop: 20px;
                  --cs-theme-team-builder-success-cta-font-size-mobile: 16px;
                  --cs-theme-team-builder-success-cta-font-size-tablet-landscape: 16px;
                  --cs-theme-team-builder-success-cta-font-size-desktop: 16px;
                  --cs-theme-team-builder-error-background-colour: #ff1e3c;
                  --cs-theme-team-builder-popup-playerlimit-title-font-size-mobile: 16px;
                  --cs-theme-team-builder-popup-playerlimit-title-font-size-tablet-landscape: 16px;
                  --cs-theme-team-builder-popup-playerlimit-title-font-size-desktop: 18px;
                  --cs-theme-team-builder-popup-playerlimit-body-font-size-mobile: 14px;
                  --cs-theme-team-builder-popup-playerlimit-body-font-size-tablet-landscape: 14px;
                  --cs-theme-team-builder-popup-playerlimit-body-font-size-desktop: 16px;
                  --cs-theme-team-builder-popup-playerlimit-drop-shadow: 0 4px 4px
                    rgba(0, 0, 0, 0.25);
                  --cs-theme-filter-singledropdown-labeltext-dark-color: #4f4f4f;
                  --cs-theme-filter-singledropdown--labeltext-light-color: #a1a1a1;
                  --cs-theme-filter-singledropdown-linktext-font-size-mobile: 16px;
                  --cs-theme-filter-singledropdown-linktext-font-size-tablet-landscape: 20px;
                  --cs-theme-filter-singledropdown-linktext-font-size-desktop: 20px;
                  --cs-theme-filter-singledropdown-selectedlabel-font-size-mobile: 16px;
                  --cs-theme-filter-singledropdown-selectedlabel-font-tablet-landscape: 13px;
                  --cs-theme-filter-singledropdown-selectedlabel-font-size-desktop: 13px;
                  --cs-theme-multi-select-section-label-font-size-mobile: 13px;
                  --cs-theme-multi-select-section-label-font-size-tablet-landscape: 13px;
                  --cs-theme-multi-select-section-label-font-size-desktop: 13px;
                  --cs-toty-animation-shine-duration: 0.4s;
                  --cs-toty-animation-shine-delay: 0.15s;
                  --cs-toty-animation-shine-steps: 9;
                  --cs-toty-animation-athlete-drop-duration: 0.833s;
                  --cs-toty-animation-athlete-drop-steps: 21;
                  --cs-toty-animation-pitch-duration: 4s;
                  --cs-toty-animation-pitch-shadow-steps: 23;
                  --cs-toty-animation-pitch-movement-min: 0;
                  --cs-toty-animation-pitch-movement-max: -8px;
                  --cs-toty-animation-pitch-movement-max-l: calc(
                    var(--cs-toty-animation-pitch-movement-max) * 2
                  );
                  --eacom-video-player-title-font-size-mobile: 16px;
                  --eacom-video-player-title-font-size-desktop: 18px;
                  --eacom-video-player-title-line-height-mobile: 100%;
                  --eacom-video-player-title-line-height-desktop: 130%;
                  --eacom-video-player-body-font-size-mobile: 12px;
                  --eacom-video-player-body-font-size-desktop: 16px;
                  --eacom-video-player-body-line-height-mobile: 100%;
                  --eacom-video-player-body-line-height-desktop: 125%;
                  --eacom-video-player-ratings-font-size-desktop: 14px;
                  --eacom-video-player-ratings-line-height-desktop: 150%;
                  --eacom-video-player-link-font-size-mobile: 12px;
                  --eacom-video-player-link-font-size-desktop: 16px;
                  --eacom-video-player-overlay-xsmall-component-space: 8px;
                  --eacom-video-player-overlay-small-component-space: 16px;
                  --eacom-video-player-overlay-medium-component-space: 24px;
                  --eacom-video-player-overlay-large-component-space: 32px;
                  --cs-loading-ellipse-color: #fff;
                  --cs-theme-tile-title-font-size-xs-mobile: 16px;
                  --cs-theme-tile-background-color: #fff;
                  --cs-theme-tile-color: var(--cs-dark-color);
                  --cs-theme-cta-standard-small-font-size-mobile: 16px;
                  --cs-theme-cta-standard-small-font-size-tablet: 16px;
                  --cs-theme-cta-standard-small-font-size-desktop: 16px;
                  --cs-theme-cta-standard-small-line-height-mobile: 1.25;
                  --cs-theme-cta-standard-small-line-height-tablet: 1.25;
                  --cs-theme-cta-standard-small-line-height-desktop: 1.25;
                  --cs-theme-cta-border-radius: 3px;
                  --cs-theme-headline-title-font-size-mobile: 24px;
                  --cs-theme-headline-title-font-size-tablet: 28px;
                  --cs-theme-headline-title-font-size-desktop: 32px;
                  --cs-theme-headline-margin-top-bottom-mobile: 16px;
                  --cs-theme-headline-margin-top-bottom-tablet: 16px;
                  --cs-theme-headline-margin-top-bottom-desktop: 16px;
                  --cs-theme-html5-video-viewport-threshold: 0.5;
                  --cs-theme-html5-video-small-component-space-tablet-landscape: 16px;
                  --cs-theme-html5-video-large-component-space-desktop: 64px;
                  --cs-theme-tile-title-font-family: var(--cs-theme-primary-font-family);
                  --cs-theme-event-details-header-font-family: "roboto-condensed",
                    "DM Sans", "Verdana", "Helvetica", "Arial", sans-serif;
                  --cs-theme-event-details-header-font-weight: bold;
                  --cs-theme-event-details-header-font-size-desktop: 18px;
                  --cs-theme-event-details-header-line-height-desktop: 24px;
                  --cs-theme-event-details-header-font-size-mobile: 16px;
                  --cs-theme-event-details-header-line-height-mobile: 24px;
                  --cs-theme-event-details-body-font-family: "ElectronicArtsText", "DM Sans",
                    "Verdana", "Helvetica", "Arial", sans-serif;
                  --cs-theme-event-details-body-font-weight: normal;
                  --cs-theme-event-details-body-font-size-desktop: 16px;
                  --cs-theme-event-details-body-line-height-desktop: 24px;
                  --cs-theme-event-details-body-font-size-mobile: 14px;
                  --cs-theme-event-details-body-line-height-mobile: 23px;
                  --cs-theme-event-tile-subheading-font-family: "roboto-condensed",
                    "DM Sans", "Verdana", "Helvetica", "Arial", sans-serif;
                  --cs-theme-event-tile-subheading-font-weight: bold;
                  --cs-theme-event-tile-subheading-font-size-desktop: 14px;
                  --cs-theme-event-tile-subheading-font-size-tablet-landscape: 14px;
                  --cs-theme-event-tile-subheading-font-size-mobile: 12px;
                  --cs-theme-event-tile-heading-font-family: "roboto-condensed", "DM Sans",
                    "Verdana", "Helvetica", "Arial", sans-serif;
                  --cs-theme-event-tile-heading-font-weight: bold;
                  --cs-theme-event-tile-heading-font-size-desktop: 22px;
                  --cs-theme-event-tile-heading-font-size-tablet-landscape: 20px;
                  --cs-theme-event-tile-heading-font-size-mobile: 20px;
                  --cs-theme-event-tile-body-font-family: "ElectronicArtsText", "DM Sans",
                    "Verdana", "Helvetica", "Arial", sans-serif;
                  --cs-theme-event-tile-body-font-size-desktop: 16px;
                  --cs-theme-event-tile-body-font-size-tablet-landscape: 14px;
                  --cs-theme-event-tile-body-font-size-mobile: 14px;
                  --cs-theme-cta-font-family: var(--cs-theme-primary-font-family);
                  --cs-theme-cta-font-size-mobile: var(--cs-theme-body-font-size-mobile);
                  --cs-theme-cta-font-size-tablet: var(
                    --cs-theme-body-font-size-tablet-landscape
                  );
                  --cs-theme-cta-font-size-desktop: var(--cs-theme-body-font-size-desktop);
                  --cs-theme-cta-line-height-mobile: var(--cs-theme-body-line-height-mobile);
                  --cs-theme-cta-line-height-tablet: var(
                    --cs-theme-body-line-height-tablet-landscape
                  );
                  --cs-theme-cta-line-height-desktop: var(--cs-theme-body-line-height-desktop);
                  --cs-theme-cta-font-weight: normal;
                  --cs-theme-cta-letter-spacing: normal;
                  --cs-theme-cta-standard-rounded-border-radius: 35px;
                  --cs-theme-local-nav-cta-dropdown-font-family: var(
                    --cs-theme-cta-font-family,
                    var(--cs-theme-primary-font-family)
                  );
                  --cs-theme-local-nav-cta-dropdown-font-size-mobile: var(
                    --cs-theme-cta-font-size-mobile,
                    var(--cs-theme-body-font-size-mobile)
                  );
                  --cs-theme-local-nav-cta-dropdown-font-size-tablet-landscape: var(
                    --cs-theme-cta-font-size-tablet,
                    var(--cs-theme-body-font-size-tablet-landscape)
                  );
                  --cs-theme-local-nav-cta-dropdown-font-size-desktop: var(
                    --cs-theme-cta-font-size-desktop,
                    var(--cs-theme-body-font-size-desktop)
                  );
                  --cs-theme-local-nav-cta-dropdown-letter-spacing-mobile: var(
                    --cs-theme-cta-letter-spacing,
                    var(--cs-theme-body-letter-spacing-mobile)
                  );
                  --cs-theme-local-nav-cta-dropdown-letter-spacing-tablet-landscape: var(
                    --cs-theme-cta-letter-spacing,
                    var(--cs-theme-body-letter-spacing-tablet-landscape)
                  );
                  --cs-theme-local-nav-cta-dropdown-letter-spacing-desktop: var(
                    --cs-theme-cta-letter-spacing,
                    var(--cs-theme-body-letter-spacing-desktop)
                  );
                  --cs-theme-submit-line-height: 3em;
                  --cs-theme-buddypass-code-font-color-light: #fff;
                  --cs-theme-buddypass-code-font-color-dark: #000;
                  --cs-theme-buddypass-code-font-size-desktop: 18px;
                  --cs-theme-buddypass-code-font-size-tablet-landscape: 16px;
                  --cs-theme-buddypass-code-font-size-mobile: 14px;
                  --cs-theme-buddypass-clipboard-font-size-desktop: 18px;
                  --cs-theme-buddypass-clipboard-font-size-tablet-landscape: 16px;
                  --cs-theme-buddypass-clipboard-font-size-mobile: 16px;
                  --cs-theme-buddypass-code-line-height-desktop: 27px;
                  --cs-theme-buddypass-code-line-height-tablet-landscape: 24px;
                  --cs-theme-buddypass-code-line-height-mobile: 17px;
                  --cs-theme-buddypass-code-line-height-xs-mobile: 17px;
                  --cs-theme-buddypass-code-margin-bottom-desktop: 32px;
                  --cs-theme-buddypass-code-margin-bottom-tablet-landscape: 24px;
                  --cs-theme-buddypass-code-margin-bottom-mobile: 24px;
                  --cs-theme-buddypass-code-margin-bottom-xs-mobile: 14px;
                  --cs-theme-buddypass-code-max-width-tablet-landscape: 357px;
                  --cs-theme-buddypass-code-max-width-mobile: 410px;
                  --cs-theme-buddypass-code-max-width-xs-mobile: 272px;
                  --cs-theme-page-feedback-subheading-font-family: var(
                    --cs-theme-secondary-font-family
                  );
                  --cs-theme-page-feedback-subheading-font-size-desktop: 40px;
                  --cs-theme-page-feedback-subheading-font-size-tablet-landscape: 30px;
                  --cs-theme-page-feedback-subheading-font-size-mobile: 24px;
                  --cs-theme-page-feedback-subheading-line-height-desktop: 112%;
                  --cs-theme-page-feedback-subheading-line-height-tablet-landscape: 112%;
                  --cs-theme-page-feedback-subheading-line-height-mobile: 112%;
                  --cs-theme-page-feedback-message-font-family: var(
                    --cs-theme-primary-font-family
                  );
                  --cs-theme-page-feedback-message-font-size-desktop: 14px;
                  --cs-theme-page-feedback-message-font-size-tablet-landscape: 14px;
                  --cs-theme-page-feedback-message-font-size-mobile: 14px;
                  --cs-theme-page-feedback-message-line-height-desktop: 140%;
                  --cs-theme-page-feedback-message-line-height-tablet-landscape: 140%;
                  --cs-theme-page-feedback-message-line-height-mobile: 140%;
                  --cs-theme-page-feedback-return-font-family: var(
                    --cs-theme-primary-font-family
                  );
                  --cs-theme-page-feedback-return-font-size-desktop: 18px;
                  --cs-theme-page-feedback-return-font-size-tablet-landscape: 16px;
                  --cs-theme-page-feedback-return-font-size-mobile: 16px;
                  --cs-theme-page-feedback-return-line-height-desktop: 150%;
                  --cs-theme-page-feedback-return-line-height-tablet-landscape: 140%;
                  --cs-theme-page-feedback-return-line-height-mobile: 140%;
                  --cs-theme-ticker-height-desktop: 3.2vw;
                  --cs-theme-ticker-height-mobile: 10vw;
                  --cs-theme-ticker-gutter-desktop: 3.7vw;
                  --cs-theme-ticker-gutter-mobile: 8vw;
                  --cs-theme-ticker-margins-desktop: 0.8vw;
                  --cs-theme-ticker-margins-mobile: 3vw;
                  --cs-theme-ticker-text-color-other: var(--cs-theme-color);
                  --cs-theme-ticker-text-font-family: var(
                    --cs-theme-typographic-headings-font-family
                  );
                  --cs-theme-ticker-text-font-size-desktop: var(
                    --cs-theme-d6-font-size-desktop
                  );
                  --cs-theme-ticker-text-font-size-mobile: var(--cs-theme-d6-font-size-mobile);
                  --cs-theme-ticker-text-line-height-desktop: var(--cs-theme-d6-line-height);
                  --cs-theme-ticker-text-line-height-mobile: var(--cs-theme-d6-line-height);
                  --cs-theme-ticker-text-font-style: var(--cs-theme-display-font-style);
                  --cs-theme-ticker-text-font-weight: var(--cs-theme-display-font-weight);
                  --cs-theme-ticker-text-align: center;
                  --cs-theme-ticker-animation-duration: 15s;
                  --cs-theme-horizontal-divider-stroke: 1px;
                  --cs-theme-horizontal-divider-top-spacer-mobile: 8px;
                  --cs-theme-horizontal-divider-top-spacer-tablet: 12px;
                  --cs-theme-horizontal-divider-top-spacer-desktop: 16px;
                  --cs-theme-horizontal-divider-bottom-spacer-mobile: 16px;
                  --cs-theme-horizontal-divider-bottom-spacer-tablet: 24px;
                  --cs-theme-horizontal-divider-bottom-spacer-desktop: 32px;
                  --cs-theme-bracket-predictor-animation-fireworks-duration: 0.766s;
                  --cs-theme-bracket-predictor-animation-fireworks-steps: 23;
                  --cs-theme-bracket-predictor-card-outline-color: #a99767;
                  --cs-theme-bracket-predictor-card-bg-color: #f6f6f6;
                  --cs-theme-bracket-predictor-card-default-bg-color: #eaeaea;
                  --cs-theme-bracket-predictor-card-selected-bg-color: #eccb71;
                  --cs-theme-bracket-predictor-card-deselected-bg-color: #fff6df;
                  --cs-theme-bracket-predictor-card-dropdown-bg-color: #fff;
                  --cs-theme-bracket-predictor-card-dropdown-deselected-flag-color: #939292;
                  --cs-theme-bracket-predictor-card-hover-color: #fff6df;
                  --cs-theme-bracket-predictor-card-font-family: "NeuePlakRegular";
                  --cs-theme-bracket-predictor-card-default-font-color: #2c2925;
                  --cs-theme-bracket-predictor-card-selected-font-color: #2c2925;
                  --cs-theme-bracket-predictor-card-deselected-font-color: #868686;
                  --cs-theme-bracket-predictor-card-font-size-mobile: 14px;
                  --cs-theme-bracket-predictor-card-font-size-desktop: 18px;
                  --cs-theme-bracket-predictor-login-desktop-font-size: 24px;
                  --cs-theme-bracket-predictor-login-tablet-font-size: 20px;
                  --cs-theme-bracket-predictor-login-mobile-font-size: 16px;
                  --cs-theme-bracket-predictor-login-font-family: "NeuePlakRegular";
                  --cs-theme-bracket-predictor-card-label-font-family: "NeuePlakSemiBold";
                  --cs-theme-bracket-predictor-card-label-font-color: #2c2925;
                  --cs-theme-bracket-predictor-card-label-font-size-mobile: 14px;
                  --cs-theme-bracket-predictor-card-label-font-size-desktop: 14px;
                  --cs-theme-bracket-predictor-finals-card-default-bg-color: #fff;
                  --cs-theme-bracket-predictor-finals-card-deselected-bg-color: linear-gradient(
                    130deg,
                    #f0e6c7 0%,
                    #fff6df 100%
                  );
                  --cs-theme-bracket-predictor-finals-card-selected-bg-color: linear-gradient(
                    130deg,
                    #ffe6a5 0%,
                    #eccb71 100%
                  );
                  --cs-theme-bracket-predictor-finals-card-font-family: "NeuePlakRegular";
                  --cs-theme-bracket-predictor-finals-card-font-size-desktop: 24px;
                  --cs-theme-bracket-predictor-finals-card-font-size-mobile: 12px;
                  --cs-theme-bracket-predictor-finals-card-label-font-family: "NeuePlakWideExtraBlack";
                  --cs-theme-bracket-predictor-finals-card-label-font-color: #2c2925;
                  --cs-theme-bracket-predictor-finals-card-label-font-size-desktop: 24px;
                  --cs-theme-bracket-predictor-finals-card-label-font-size-mobile: 14px;
                  --cs-theme-bracket-predictor-radio-icon-default: #2c2925;
                  --cs-theme-bracket-predictor-radio-icon-selected: #2c2925;
                  --cs-theme-bracket-predictor-radio-icon-deselected: #868686;
                  --cs-theme-bracket-predictor-tabs-font-family: "NeuePlakWideExtraBlack";
                  --cs-theme-bracket-predictor-tabs-font-weight: 900;
                  --cs-theme-bracket-predictor-tabs-desktop-font-size: 24px;
                  --cs-theme-bracket-predictor-tabs-mobile-font-size: 14px;
                  --cs-theme-bracket-predictor-tabs-active-text-color: #2c2925;
                  --cs-theme-bracket-predictor-tabs-inactive-text-color: #aaa;
                  --cs-theme-bracket-predictor-tabs-underline: #a99767;
                  --cs-theme-bracket-predictor-tabs-active-underline: #eccb71;
                  --cs-theme-bracket-predictor-tabs-underline-stroke-width: 1px;
                  --cs-theme-bracket-predictor-tabs-active-underline-stroke-width: 3px;
                  --cs-theme-bracket-predictor-tabs-light-color: var(--cs-light-color);
                  --cs-theme-bracket-predictor-tabs-dark-color: var(--cs-dark-color);
                  --cs-theme-bracket-predictor-next-cta-bg-disabled: #bababa;
                  --cs-theme-bracket-predictor-stage-title-font-family: "NeuePlakRegular";
                  --cs-theme-bracket-predictor-next-cta-bg-enabled: #2c2925;
                  --cs-theme-bracket-predictor-finals-next-cta-bg-enabled: #ff5e0c;
                  --cs-theme-bracket-predictor-next-cta-mobile-bg: #fff;
                  --cs-theme-bracket-predictor-popup-primary-font-family: "NeuePlakRegular";
                  --cs-theme-bracket-predictor-popup-secondary-font-family: "NeuePlakWideExtraBlack";
                  --cs-theme-bracket-predictor-popup-heading-font-size-desktop: 36px;
                  --cs-theme-bracket-predictor-popup-heading-font-size-mobile: 20px;
                  --cs-theme-bracket-predictor-popup-sub-heading-font-size-desktop: 18px;
                  --cs-theme-bracket-predictor-popup-sub-heading-font-size-mobile: 16px;
                  --cs-theme-bracket-predictor-popup-body-font-size-desktop: 16px;
                  --cs-theme-bracket-predictor-popup-body-font-size-mobile: 14px;
                  --cs-theme-bracket-predictor-popup-success-cta-font-size-desktop: 16px;
                  --cs-theme-bracket-predictor-popup-success-cta-font-size-mobile: 15px;
                  --cs-theme-bracket-predictor-popup-share-icon-bg-color: linear-gradient(
                    180deg,
                    #cbb987 0%,
                    #a99767 100%
                  );
                  --cs-theme-bracket-predictor-popup-download-btn-bg-color: linear-gradient(
                    180deg,
                    #cbb987 0%,
                    #a99767 100%
                  );
                  --cs-theme-bracket-predictor-popup-next-step-stripe-gradient-bg-color: linear-gradient(
                    95deg,
                    #097045 45%,
                    #26593d 60%
                  );
                  --cs-theme-bracket-predictor-popup-next-step-stripe-font-family: "NeuePlakWideExtraBlack";
                  --cs-theme-bracket-predictor-popup-next-step-stripe-font-size-desktop: 14px;
                  --cs-theme-bracket-predictor-popup-next-step-stripe-font-size-mobile: 12px;
                  --cs-theme-bracket-predictor-popup-error-heading-font-size-mobile: 20px;
                  --cs-theme-bracket-predictor-popup-error-heading-font-size-tablet-landscape: 28px;
                  --cs-theme-bracket-predictor-popup-error-heading-font-size-desktop: 32px;
                  --cs-theme-bracket-predictor-popup-error-body-font-size-mobile: 14px;
                  --cs-theme-bracket-predictor-popup-error-body-font-size-tablet-landscape: 16px;
                  --cs-theme-bracket-predictor-popup-error-body-font-size-desktop: 16px;
                  --cs-theme-esports-leaderboard-search-label-font-size-mobile: 14px;
                  --cs-theme-esports-leaderboard-search-label-font-size-tablet-landscape: 16px;
                  --cs-theme-esports-leaderboard-search-label-font-size-desktop: 16px;
                  --cs-theme-esports-leaderboard-header-line-height-mobile: 100%;
                  --cs-theme-esports-leaderboard-header-line-height-tablet-landscape: 100%;
                  --cs-theme-esports-leaderboard-header-line-height-desktop: 100%;
                  --cs-theme-esports-leaderboard-rank-font-size-mobile: 16px;
                  --cs-theme-esports-leaderboard-rank-font-size-tablet-landscape: 16px;
                  --cs-theme-esports-leaderboard-rank-font-size-desktop: 18px;
                  --cs-theme-esports-leaderboard-rank-line-height-mobile: 100%;
                  --cs-theme-esports-leaderboard-rank-line-height-tablet-landscape: 100%;
                  --cs-theme-esports-leaderboard-rank-line-height-desktop: 100%;
                  --cs-theme-esports-leaderboard-search-result-font-size-mobile: 14px;
                  --cs-theme-esports-leaderboard-search-result-font-size-tablet-landscape: 16px;
                  --cs-theme-esports-leaderboard-search-result-font-size-desktop: 18px;
                  --cs-theme-esports-leaderboard-search-result-line-height-mobile: 100%;
                  --cs-theme-esports-leaderboard-search-result-line-height-tablet-landscape: 100%;
                  --cs-theme-esports-leaderboard-search-result-line-height-desktop: 100%;
                  --cs-theme-esports-leaderboard-game-title-font-size-mobile: 16px;
                  --cs-theme-esports-leaderboard-game-title-font-size-tablet-landscape: 16px;
                  --cs-theme-esports-leaderboard-game-title-font-size-desktop: 16px;
                  --cs-theme-esports-leaderboard-game-title-line-height-mobile: 100%;
                  --cs-theme-esports-leaderboard-game-title-line-height-tablet-landscape: 100%;
                  --cs-theme-esports-leaderboard-game-title-line-height-desktop: 100%;
                  --cs-theme-esports-leaderboard-header-font-size-mobile: 14px;
                  --cs-theme-esports-leaderboard-header-font-size-tablet-landscape: 14px;
                  --cs-theme-esports-leaderboard-header-font-size-desktop: 16px;
                  --cs-theme-esports-leaderboard-name-font-size-mobile: 14px;
                  --cs-theme-esports-leaderboard-name-font-size-tablet-landscape: 16px;
                  --cs-theme-esports-leaderboard-name-font-size-desktop: 18px;
                  --cs-theme-esports-leaderboard-name-line-height-mobile: 100%;
                  --cs-theme-esports-leaderboard-name-line-height-tablet-landscape: 100%;
                  --cs-theme-esports-leaderboard-name-line-height-desktop: 100%;
                  --cs-theme-esports-leaderboard-points-font-size-mobile: 14px;
                  --cs-theme-esports-leaderboard-points-font-size-tablet-landscape: 16px;
                  --cs-theme-esports-leaderboard-points-font-size-desktop: 18px;
                  --cs-theme-esports-leaderboard-points-line-height-mobile: 100%;
                  --cs-theme-esports-leaderboard-points-line-height-tablet-landscape: 100%;
                  --cs-theme-esports-leaderboard-points-line-height-desktop: 100%;
                  --cs-theme-esports-leaderboard-stats-font-size-mobile: 14px;
                  --cs-theme-esports-leaderboard-stats-font-size-tablet-landscape: 16px;
                  --cs-theme-esports-leaderboard-stats-font-size-desktop: 18px;
                  --cs-theme-esports-leaderboard-stats-line-height-mobile: 100%;
                  --cs-theme-esports-leaderboard-stats-line-height-tablet-landscape: 100%;
                  --cs-theme-esports-leaderboard-stats-line-height-desktop: 100%;
                  --cs-theme-esports-leaderboard-annotation-font-size-mobile: 14px;
                  --cs-theme-esports-leaderboard-annotation-font-size-tablet-landscape: 14px;
                  --cs-theme-esports-leaderboard-annotation-font-size-desktop: 14px;
                  --cs-theme-esports-leaderboard-annotation-line-height-mobile: 100%;
                  --cs-theme-esports-leaderboard-annotation-line-height-tablet-landscape: 100%;
                  --cs-theme-esports-leaderboard-annotation-line-height-desktop: 100%;
                  --cs-theme-esports-leaderboard-name-expanded-font-size-mobile: 12px;
                  --cs-theme-esports-leaderboard-name-expanded-font-size-tablet-landscape: 14px;
                  --cs-theme-esports-leaderboard-name-expanded-font-size-desktop: 16px;
                  --cs-theme-esports-leaderboard-name-expanded-line-height-mobile: 120%;
                  --cs-theme-esports-leaderboard-name-expanded-line-height-tablet-landscape: 120%;
                  --cs-theme-esports-leaderboard-name-expanded-line-height-desktop: 120%;
                  --cs-theme-esports-leaderboard-separator-font-size-mobile: 12px;
                  --cs-theme-esports-leaderboard-separator-font-size-tablet-landscape: 16px;
                  --cs-theme-esports-leaderboard-separator-font-size-desktop: 16px;
                  --cs-theme-esports-leaderboard-separator-line-height-mobile: 140%;
                  --cs-theme-esports-leaderboard-separator-line-height-tablet-landscape: 140%;
                  --cs-theme-esports-leaderboard-separator-line-height-desktop: 140%;
                  --cs-theme-esports-leaderboard-error-font-size: 24px;
                  --cs-theme-esports-leaderboard-error-line-height: 100%;
                  --cs-theme-comparison-tile-header-font-family: var(
                    --cs-theme-cs-corporate-header-font-family
                  );
                  --cs-theme-comparison-tile-body-font-family: var(
                    --cs-theme-cs-corporate-body-font-family
                  );
                  --cs-theme-comparison-disclaimer-font-family: var(
                    --cs-theme-comparison-tile-body-font-family
                  );
                  --cs-theme-comparison-disclaimer-font-weight: normal;
                  --cs-theme-comparison-disclaimer-font-size: 12px;
                  --cs-theme-comparison-disclaimer-letter-spacing: 2.5%;
                  --cs-theme-comparison-disclaimer-line-height: 135%;
                  --cs-theme-comparison-tile-eyebrow-font-family: var(
                    --cs-theme-comparison-tile-header-font-family
                  );
                  --cs-theme-comparison-tile-eyebrow-font-weight: bold;
                  --cs-theme-comparison-tile-eyebrow-font-size-mobile: 16px;
                  --cs-theme-comparison-tile-eyebrow-font-size-tablet: var(
                    --cs-theme-comparison-tile-eyebrow-font-size-mobile
                  );
                  --cs-theme-comparison-tile-eyebrow-font-size-desktop: 18px;
                  --cs-theme-comparison-tile-eyebrow-line-height-mobile: 100%;
                  --cs-theme-comparison-tile-eyebrow-line-height-tablet: var(
                    --cs-theme-comparison-tile-eyebrow-line-height-mobile
                  );
                  --cs-theme-comparison-tile-eyebrow-line-height-desktop: 100%;
                  --cs-theme-comparison-tile-price-font-family: var(
                    --cs-theme-comparison-tile-header-font-family
                  );
                  --cs-theme-comparison-tile-price-font-weight: bold;
                  --cs-theme-comparison-tile-price-font-size-mobile: 32px;
                  --cs-theme-comparison-tile-price-font-size-tablet: var(
                    --cs-theme-comparison-tile-price-font-size-mobile
                  );
                  --cs-theme-comparison-tile-price-font-size-desktop: 40px;
                  --cs-theme-comparison-tile-price-line-height-mobile: 100%;
                  --cs-theme-comparison-tile-price-line-height-tablet: var(
                    --cs-theme-comparison-tile-price-line-height-mobile
                  );
                  --cs-theme-comparison-tile-price-line-height-desktop: 100%;
                  --cs-theme-comparison-tile-unit-font-family: var(
                    --cs-theme-comparison-tile-header-font-family
                  );
                  --cs-theme-comparison-tile-unit-font-weight: bold;
                  --cs-theme-comparison-tile-unit-font-size-mobile: 50%;
                  --cs-theme-comparison-tile-unit-font-size-tablet: var(
                    --cs-theme-comparison-tile-unit-font-size-mobile
                  );
                  --cs-theme-comparison-tile-unit-font-size-desktop: 50%;
                  --cs-theme-comparison-tile-unit-line-height-mobile: 100%;
                  --cs-theme-comparison-tile-unit-line-height-tablet: var(
                    --cs-theme-comparison-tile-unit-line-height-mobile
                  );
                  --cs-theme-comparison-tile-unit-line-height-desktop: 100%;
                  --cs-theme-comparison-tile-body-font-weight: normal;
                  --cs-theme-comparison-tile-body-font-size-mobile: 16px;
                  --cs-theme-comparison-tile-body-font-size-tablet: var(
                    --cs-theme-comparison-tile-body-font-size-mobile
                  );
                  --cs-theme-comparison-tile-body-font-size-desktop: 18px;
                  --cs-theme-comparison-tile-body-line-height-mobile: 135%;
                  --cs-theme-comparison-tile-body-line-height-tablet: var(
                    --cs-theme-comparison-tile-body-line-height-mobile
                  );
                  --cs-theme-comparison-tile-body-line-height-desktop: 135%;
                }





                :host {
                    --cs-dark-color: #212121;
                    --cs-light-color: #eee;
                    --cs-dark-color-rgb: 22, 22, 22;
                    --cs-light-color-rgb: 243, 243, 243;
                    --origin-brand-color: #f56c2c;
                    --cs-access-brand-color: #2d3c51;
                    --xbox-brand-color: #52b043;
                    --playstation-brand-color: #003087;
                    --nintendo-brand-color: #fe0016;
                    --cs-success-color: #00dc8f;
                    --cs-error-color: #ff6969;
                    --mdc-theme-error: #ff6969;

                    --cs-theme-translucent-foreground: hsl(0, 0%, 98%);
                    --cs-theme-color: #2d3c51;
                    --cs-theme-secondary-color: #47886a;
                    --cs-color-black: #000;
                    --cs-color-blue: #2d3c51;
                    --cs-color-dark-blue: #232F3E;
                    --cs-color-dark-blue-hard: #131A22;
                    --cs-color-gray: #a3a3a3;
                    --cs-color-light-gray: #f3f3f3;
                    --cs-color-white: #fff;
                    --cs-color-xbox-green: #029e10;
                }




                :host {
                    --cs-zero: 0;
                    --cs-rail-mobile: 7.5vw;
                    --cs-rail-tablet-portrait: 7.8125vw;
                    --cs-rail-tablet-landscape: 7.4218vw;
                    --cs-rail-desktop: calc((100vw - 1420px) / 2);
                    --cs-gutter-mobile: 16px;
                    --cs-gutter-tablet-portrait: 24px;
                    --cs-gutter-tablet-landscape: 28px;
                    --cs-gutter-desktop: 32px;
                    --cs-column-mobile: calc((100vw - 2 * var(--cs-rail-mobile) - var(--cs-gutter-mobile) * 5) / 6);
                    --cs-column-tablet-portrait: calc((100vw - 2 * var(--cs-rail-tablet-portrait) - var(--cs-gutter-tablet-portrait) * 11) / 12);
                    --cs-column-tablet-landscape: calc((100vw - 2 * var(--cs-rail-tablet-landscape) - var(--cs-gutter-tablet-landscape) * 11) / 12);
                    --cs-column-desktop: calc((100vw - 2 * var(--cs-rail-desktop) - var(--cs-gutter-desktop) * 11) / 12);
                    --cs-column-mobile-with-rail: calc((100vw - (var(--cs-gutter-mobile) * 5 + var(--cs-rail-mobile) * 2)) / 6);
                    --cs-column-tablet-portrait-with-rail: calc((100vw - (var(--cs-gutter-tablet-portrait) * 11 + var(--cs-rail-tablet-portrait) * 2)) / 12);
                    --cs-column-tablet-landscape-with-rail: calc((100vw - (var(--cs-gutter-tablet-landscape) * 11 + var(--cs-rail-tablet-landscape) * 2)) / 12);
                    --cs-column-desktop-with-rail: calc((100vw - (var(--cs-gutter-desktop) * 11 + var(--cs-rail-desktop) * 2)) / 12);
                    --cs-small-component-space-mobile: 24px;
                    --cs-small-component-space-tablet-portrait: 28px;
                    --cs-small-component-space-tablet-landscape: 32px;
                    --cs-small-component-space-desktop: 36px;
                    --cs-medium-component-space-mobile: 40px;
                    --cs-medium-component-space-tablet-portrait: 48px;
                    --cs-medium-component-space-tablet-landscape: 56px;
                    --cs-medium-component-space-desktop: 64px;
                    --cs-large-component-space-mobile: 72px;
                    --cs-large-component-space-tablet-portrait: 82px;
                    --cs-large-component-space-tablet-landscape: 92px;
                    --cs-large-component-space-desktop: 112px;
                }




                :host {
                    --cs-modal-layer: 102;
                    --cs-network-nav-layer: 300;
                    --cs-local-nav-layer: 101;
                    --cs-sub-nav-layer: 100;
                    --cs-filter-layer: 99;
                }



                :host {
                    --layout: {
                        display: -ms-flexbox;
                        display: -webkit-flex;
                        display: flex
                    }

                    ;

                    --layout-inline: {
                        display: -ms-inline-flexbox;
                        display: -webkit-inline-flex;
                        display: inline-flex
                    }

                    ;

                    --layout-horizontal: {
                        @apply --layout;
                        -ms-flex-direction: row;
                        -webkit-flex-direction: row;
                        flex-direction: row
                    }

                    ;

                    --layout-horizontal-reverse: {
                        @apply --layout;
                        -ms-flex-direction: row-reverse;
                        -webkit-flex-direction: row-reverse;
                        flex-direction: row-reverse
                    }

                    ;

                    --layout-vertical: {
                        @apply --layout;
                        -ms-flex-direction: column;
                        -webkit-flex-direction: column;
                        flex-direction: column
                    }

                    ;

                    --layout-vertical-reverse: {
                        @apply --layout;
                        -ms-flex-direction: column-reverse;
                        -webkit-flex-direction: column-reverse;
                        flex-direction: column-reverse
                    }

                    ;

                    --layout-wrap: {
                        -ms-flex-wrap: wrap;
                        -webkit-flex-wrap: wrap;
                        flex-wrap: wrap
                    }

                    ;

                    --layout-wrap-reverse: {
                        -ms-flex-wrap: wrap-reverse;
                        -webkit-flex-wrap: wrap-reverse;
                        flex-wrap: wrap-reverse
                    }

                    ;

                    --layout-flex-auto: {
                        -ms-flex: 1 1 auto;
                        -webkit-flex: 1 1 auto;
                        flex: 1 1 auto
                    }

                    ;

                    --layout-flex-none: {
                        -ms-flex: none;
                        -webkit-flex: none;
                        flex: none
                    }

                    ;

                    --layout-flex: {
                        -ms-flex: 1 1 .000000001px;
                        -webkit-flex: 1;
                        flex: 1;
                        -webkit-flex-basis: .000000001px;
                        flex-basis: .000000001px
                    }

                    ;

                    --layout-flex-2: {
                        -ms-flex: 2;
                        -webkit-flex: 2;
                        flex: 2
                    }

                    ;

                    --layout-flex-3: {
                        -ms-flex: 3;
                        -webkit-flex: 3;
                        flex: 3
                    }

                    ;

                    --layout-flex-4: {
                        -ms-flex: 4;
                        -webkit-flex: 4;
                        flex: 4
                    }

                    ;

                    --layout-flex-5: {
                        -ms-flex: 5;
                        -webkit-flex: 5;
                        flex: 5
                    }

                    ;

                    --layout-flex-6: {
                        -ms-flex: 6;
                        -webkit-flex: 6;
                        flex: 6
                    }

                    ;

                    --layout-flex-7: {
                        -ms-flex: 7;
                        -webkit-flex: 7;
                        flex: 7
                    }

                    ;

                    --layout-flex-8: {
                        -ms-flex: 8;
                        -webkit-flex: 8;
                        flex: 8
                    }

                    ;

                    --layout-flex-9: {
                        -ms-flex: 9;
                        -webkit-flex: 9;
                        flex: 9
                    }

                    ;

                    --layout-flex-10: {
                        -ms-flex: 10;
                        -webkit-flex: 10;
                        flex: 10
                    }

                    ;

                    --layout-flex-11: {
                        -ms-flex: 11;
                        -webkit-flex: 11;
                        flex: 11
                    }

                    ;

                    --layout-flex-12: {
                        -ms-flex: 12;
                        -webkit-flex: 12;
                        flex: 12
                    }

                    ;

                    --layout-start: {
                        -ms-flex-align: start;
                        -webkit-align-items: flex-start;
                        align-items: flex-start
                    }

                    ;

                    --layout-center: {
                        -ms-flex-align: center;
                        -webkit-align-items: center;
                        align-items: center
                    }

                    ;

                    --layout-end: {
                        -ms-flex-align: end;
                        -webkit-align-items: flex-end;
                        align-items: flex-end
                    }

                    ;

                    --layout-baseline: {
                        -ms-flex-align: baseline;
                        -webkit-align-items: baseline;
                        align-items: baseline
                    }

                    ;

                    --layout-start-justified: {
                        -ms-flex-pack: start;
                        -webkit-justify-content: flex-start;
                        justify-content: flex-start
                    }

                    ;

                    --layout-center-justified: {
                        -ms-flex-pack: center;
                        -webkit-justify-content: center;
                        justify-content: center
                    }

                    ;

                    --layout-end-justified: {
                        -ms-flex-pack: end;
                        -webkit-justify-content: flex-end;
                        justify-content: flex-end
                    }

                    ;

                    --layout-around-justified: {
                        -ms-flex-pack: distribute;
                        -webkit-justify-content: space-around;
                        justify-content: space-around
                    }

                    ;

                    --layout-justified: {
                        -ms-flex-pack: justify;
                        -webkit-justify-content: space-between;
                        justify-content: space-between
                    }

                    ;

                    --layout-center-center: {
                        @apply --layout-center;
                        @apply --layout-center-justified;
                    }

                    ;

                    --layout-self-start: {
                        -ms-align-self: flex-start;
                        -webkit-align-self: flex-start;
                        align-self: flex-start
                    }

                    ;

                    --layout-self-center: {
                        -ms-align-self: center;
                        -webkit-align-self: center;
                        align-self: center
                    }

                    ;

                    --layout-self-end: {
                        -ms-align-self: flex-end;
                        -webkit-align-self: flex-end;
                        align-self: flex-end
                    }

                    ;

                    --layout-self-stretch: {
                        -ms-align-self: stretch;
                        -webkit-align-self: stretch;
                        align-self: stretch
                    }

                    ;

                    --layout-self-baseline: {
                        -ms-align-self: baseline;
                        -webkit-align-self: baseline;
                        align-self: baseline
                    }

                    ;

                    --layout-start-aligned: {
                        -ms-flex-line-pack: start;
                        -ms-align-content: flex-start;
                        -webkit-align-content: flex-start;
                        align-content: flex-start
                    }

                    ;

                    --layout-end-aligned: {
                        -ms-flex-line-pack: end;
                        -ms-align-content: flex-end;
                        -webkit-align-content: flex-end;
                        align-content: flex-end
                    }

                    ;

                    --layout-center-aligned: {
                        -ms-flex-line-pack: center;
                        -ms-align-content: center;
                        -webkit-align-content: center;
                        align-content: center
                    }

                    ;

                    --layout-between-aligned: {
                        -ms-flex-line-pack: justify;
                        -ms-align-content: space-between;
                        -webkit-align-content: space-between;
                        align-content: space-between
                    }

                    ;

                    --layout-around-aligned: {
                        -ms-flex-line-pack: distribute;
                        -ms-align-content: space-around;
                        -webkit-align-content: space-around;
                        align-content: space-around
                    }

                    ;

                    --layout-block: {
                        display: block
                    }

                    ;

                    --layout-invisible: {
                        visibility: hidden !important
                    }

                    ;

                    --layout-relative: {
                        position: relative
                    }

                    ;

                    --layout-fit: {
                        position: absolute;
                        top: 0;
                        right: 0;
                        bottom: 0;
                        left: 0
                    }

                    ;

                    --layout-scroll: {
                        -webkit-overflow-scrolling: touch;
                        overflow: auto
                    }

                    ;

                    --layout-fullbleed: {
                        margin: 0;
                        height: 100vh
                    }

                    ;

                    --layout-fixed-top: {
                        position: fixed;
                        top: 0;
                        left: 0;
                        right: 0
                    }

                    ;

                    --layout-fixed-right: {
                        position: fixed;
                        top: 0;
                        right: 0;
                        bottom: 0
                    }

                    ;

                    --layout-fixed-bottom: {
                        position: fixed;
                        right: 0;
                        bottom: 0;
                        left: 0
                    }

                    ;

                    --layout-fixed-left: {
                        position: fixed;
                        top: 0;
                        bottom: 0;
                        left: 0
                    }

                    ;
                }




                .h1,
                .h2,
                .h3,
                .h4,
                .h5,
                .h6,
                h1,
                h2,
                h3,
                h4,
                h5,
                h6 {
                    transition: opacity var(--cs-interface-expansion)
                }

                :host([wf-loading]) .h1,
                :host([wf-loading]) .h2,
                :host([wf-loading]) .h3,
                :host([wf-loading]) .h4,
                :host([wf-loading]) .h5,
                :host([wf-loading]) .h6,
                :host([wf-loading]) h1,
                :host([wf-loading]) h2,
                :host([wf-loading]) h3,
                :host([wf-loading]) h4,
                :host([wf-loading]) h5,
                :host([wf-loading]) h6 {
                    opacity: 0
                }

                .h1-brand-light,
                .h1-light,
                .h2-brand-light,
                .h2-light,
                .h3-brand-light,
                .h3-light,
                .h4-brand-light,
                .h4-light,
                .h5-brand-light,
                .h5-light,
                .h6-brand-light,
                .h6-light {
                    color: var(--cs-light-color)
                }

                .h1,
                h1 {
                    font-size: var(--cs-theme-h1-font-size-mobile);
                    font-weight: var(--cs-theme-h1-font-weight);
                    letter-spacing: var(--cs-theme-h1-letter-spacing-mobile);
                    line-height: var(--cs-theme-h1-line-height-mobile)
                }

                h1 {
                    margin: var(--cs-theme-h1-margin-mobile)
                }

                @media only screen and (min-width:768px) {
                    h1 {
                        margin: var(--cs-theme-h1-margin-tablet-portrait)
                    }

                }

                @media only screen and (min-width:1024px) {

                    .h1,
                    h1 {
                        font-size: var(--cs-theme-h1-font-size-tablet-landscape);
                        letter-spacing: var(--cs-theme-h1-letter-spacing-tablet-landscape);
                        line-height: var(--cs-theme-h1-line-height-tablet-landscape)
                    }

                    h1 {
                        margin: var(--cs-theme-h1-margin-tablet-landscape)
                    }

                }

                @media only screen and (min-width:1456px) {

                    .h1,
                    h1 {
                        font-size: var(--cs-theme-h1-font-size-desktop);
                        letter-spacing: var(--cs-theme-h1-letter-spacing-desktop);
                        line-height: var(--cs-theme-h1-line-height-desktop)
                    }

                    h1 {
                        margin: var(--cs-theme-h1-margin-desktop)
                    }

                }

                .h2,
                h2 {
                    font-size: var(--cs-theme-h2-font-size-mobile);
                    font-weight: var(--cs-theme-h2-font-weight);
                    letter-spacing: var(--cs-theme-h2-letter-spacing-mobile);
                    line-height: var(--cs-theme-h2-line-height-mobile)
                }

                h2 {
                    margin: var(--cs-theme-h2-margin-mobile)
                }

                .l2:not([hidden])+.h2 {
                    margin-top: var(--cs-theme-h2-after-l2-margin-top-mobile)
                }

                @media only screen and (min-width:768px) {
                    h2 {
                        margin: var(--cs-theme-h2-margin-tablet-portrait)
                    }

                }

                @media only screen and (min-width:1024px) {

                    .h2,
                    h2 {
                        font-size: var(--cs-theme-h2-font-size-tablet-landscape);
                        letter-spacing: var(--cs-theme-h2-letter-spacing-tablet-landscape);
                        line-height: var(--cs-theme-h2-line-height-tablet-landscape)
                    }

                    h2 {
                        margin: var(--cs-theme-h2-margin-tablet-landscape)
                    }

                    .l2:not([hidden])+.h2 {
                        margin-top: var(--cs-theme-h2-after-l2-margin-top-tablet-landscape)
                    }

                }

                @media only screen and (min-width:1456px) {

                    .h2,
                    h2 {
                        font-size: var(--cs-theme-h2-font-size-desktop);
                        letter-spacing: var(--cs-theme-h2-letter-spacing-desktop);
                        line-height: var(--cs-theme-h2-line-height-desktop)
                    }

                    h2 {
                        margin: var(--cs-theme-h2-margin-desktop)
                    }

                    .l2:not([hidden])+.h2 {
                        margin-top: var(--cs-theme-h2-after-l2-margin-top-desktop)
                    }

                }

                .h3,
                h3 {
                    font-size: var(--cs-theme-h3-font-size-mobile);
                    font-weight: var(--cs-theme-h3-font-weight);
                    letter-spacing: var(--cs-theme-h3-letter-spacing-mobile);
                    line-height: var(--cs-theme-h3-line-height-mobile)
                }

                h3 {
                    margin: var(--cs-theme-h3-margin-mobile)
                }

                @media only screen and (min-width:768px) {
                    h3 {
                        margin: var(--cs-theme-h3-margin-tablet-portrait)
                    }

                }

                @media only screen and (min-width:1024px) {

                    .h3,
                    h3 {
                        font-size: var(--cs-theme-h3-font-size-tablet-landscape);
                        letter-spacing: var(--cs-theme-h3-letter-spacing-tablet-landscape);
                        line-height: var(--cs-theme-h3-line-height-tablet-landscape)
                    }

                    h3 {
                        margin: var(--cs-theme-h3-margin-tablet-landscape)
                    }

                }

                @media only screen and (min-width:1456px) {

                    .h3,
                    h3 {
                        font-size: var(--cs-theme-h3-font-size-desktop);
                        letter-spacing: var(--cs-theme-h3-letter-spacing-desktop);
                        line-height: var(--cs-theme-h3-line-height-desktop)
                    }

                    h3 {
                        margin: var(--cs-theme-h3-margin-desktop)
                    }

                }

                .h4,
                h4 {
                    font-size: var(--cs-theme-h4-font-size-mobile);
                    font-weight: var(--cs-theme-h4-font-weight);
                    letter-spacing: var(--cs-theme-h4-letter-spacing-mobile);
                    line-height: var(--cs-theme-h4-line-height-mobile)
                }

                h4 {
                    margin: var(--cs-theme-h4-margin-mobile)
                }

                .d1:not([hidden])+.h4 {
                    margin-top: var(--cs-theme-h4-after-d1-margin-top-mobile)
                }

              .d2:not([hidden])+.h4 {
                    margin-top: var(--cs-theme-h4-after-d2-margin-top-mobile)
                }

                .d3:not([hidden])+.h4 {
                    margin-top: var(--cs-theme-h4-after-d3-margin-top-mobile)
                }

                .d4:not([hidden])+.h4 {
                    margin-top: var(--cs-theme-h4-after-d4-margin-top-mobile)
                }

                .l2:not([hidden])+.h4 {
                    margin-top: var(--cs-theme-h4-after-l2-margin-top-mobile)
                }

                img+dom-if+.h4,
                img+dom-if+[hidden]+.h4 {
                    margin-top: 26px
                }

                @media only screen and (min-width:768px) {
                    .d1:not([hidden])+.h4 {
                        margin-top: var(--cs-theme-h4-after-d1-margin-top-tablet-portrait)
                    }

                    .d2:not([hidden])+.h4 {
                        margin-top: var(--cs-theme-h4-after-d2-margin-top-tablet-portrait)
                    }

                    .d3:not([hidden])+.h4 {
                        margin-top: var(--cs-theme-h4-after-d3-margin-top-tablet-portrait)
                    }

                }

                @media only screen and (min-width:768px) {
                    h4 {
                        margin: var(--cs-theme-h4-margin-tablet-portrait)
                    }

                }

                @media only screen and (min-width:1024px) {

                    .h4,
                    h4 {
                        font-size: var(--cs-theme-h4-font-size-tablet-landscape);
                        letter-spacing: var(--cs-theme-h4-letter-spacing-tablet-landscape);
                        line-height: var(--cs-theme-h4-line-height-tablet-landscape)
                    }

                    h4 {
                        margin: var(--cs-theme-h4-margin-tablet-landscape)
                    }

                    .d1:not([hidden])+.h4 {
                        margin-top: var(--cs-theme-h4-after-d1-margin-top-tablet-landscape)
                    }

                    .d2:not([hidden])+.h4 {
                        margin-top: var(--cs-theme-h4-after-d2-margin-top-tablet-landscape)
                    }

                    .d3:not([hidden])+.h4 {
                        margin-top: var(--cs-theme-h4-after-d3-margin-top-tablet-landscape)
                    }

                    .d4:not([hidden])+.h4 {
                        margin-top: var(--cs-theme-h4-after-d4-margin-top-tablet-landscape)
                    }

                    .l2:not([hidden])+.h4 {
                        margin-top: var(--cs-theme-h4-after-l2-margin-top-tablet-landscape)
                    }

                    img+dom-if+.h4,
                    img+dom-if+[hidden]+.h4 {
                        margin-top: 32px
                    }

                }

                @media only screen and (min-width:1456px) {

                    .h4,
                    h4 {
                        font-size: var(--cs-theme-h4-font-size-desktop);
                        letter-spacing: var(--cs-theme-h4-letter-spacing-desktop);
                        line-height: var(--cs-theme-h4-line-height-desktop)
                    }

                    h4 {
                        margin: var(--cs-theme-h4-margin-desktop)
                    }

                    .d1:not([hidden])+.h4 {
                        margin-top: var(--cs-theme-h4-after-d1-margin-top-desktop)
                    }

                    .d3:not([hidden])+.h4 {
                        margin-top: var(--cs-theme-h4-after-d3-margin-top-desktop)
                    }

                    .d4:not([hidden])+.h4 {
                        margin-top: var(--cs-theme-h4-after-d4-margin-top-desktop)
                    }

                    .l2:not([hidden])+.h4 {
                        margin-top: var(--cs-theme-h4-after-l2-margin-top-desktop)
                    }

                    img+dom-if+.h4,
                    img+dom-if+[hidden]+.h4 {
                        margin-top: 40px
                    }

                }

                .h5,
                h5 {
                    font-size: var(--cs-theme-h5-font-size-mobile);
                    font-weight: var(--cs-theme-h5-font-weight);
                    letter-spacing: var(--cs-theme-h5-letter-spacing-mobile);
                    line-height: var(--cs-theme-h5-line-height-mobile)
                }

                h5 {
                    margin: var(--cs-theme-h5-margin-mobile)
                }

                .l2:not([hidden])+.h5 {
                    margin-top: var(--cs-theme-h5-after-l2-margin-top-mobile)
                }

                @media only screen and (min-width:768px) {
                    h5 {
                        margin: var(--cs-theme-h5-margin-tablet-portrait)
                    }

                }

                @media only screen and (min-width:1024px) {

                    .h5,
                    h5 {
                        font-size: var(--cs-theme-h5-font-size-tablet-landscape);
                        letter-spacing: var(--cs-theme-h5-letter-spacing-tablet-landscape);
                        line-height: var(--cs-theme-h5-line-height-tablet-landscape)
                    }

                    h5 {
                        margin: var(--cs-theme-h5-margin-tablet-landscape)
                    }

                    .l2:not([hidden])+.h5 {
                        margin-top: var(--cs-theme-h5-after-l2-margin-top-tablet-landscape)
                    }

                }

                @media only screen and (min-width:1456px) {

                    .h5,
                    h5 {
                        font-size: var(--cs-theme-h5-font-size-desktop);
                        letter-spacing: var(--cs-theme-h5-letter-spacing-desktop);
                        line-height: var(--cs-theme-h5-line-height-desktop)
                    }

                    h5 {
                        margin: var(--cs-theme-h5-margin-desktop)
                    }

                    .l2:not([hidden])+.h5 {
                        margin-top: var(--cs-theme-h5-after-l2-margin-top-desktop)
                    }

                }

                .h6,
                h6 {
                    font-size: var(--cs-theme-h6-font-size-mobile);
                    font-weight: var(--cs-theme-h6-font-weight);
                    letter-spacing: var(--cs-theme-h6-letter-spacing-mobile);
                    line-height: var(--cs-theme-h6-line-height-mobile)
                }

                h6 {
                    margin: var(--cs-theme-h6-margin-mobile)
                }

                .d3:not([hidden])+.h6 {
                    margin-top: var(--cs-theme-h6-after-d3-margin-top-mobile)
                }

                .l2:not([hidden])+.h6 {
                    margin-top: var(--cs-theme-h6-after-l2-margin-top-mobile)
                }

                @media only screen and (min-width:768px) {
                    h6 {
                        margin: var(--cs-theme-h6-margin-tablet-portrait)
                    }

                }

                @media only screen and (min-width:1024px) {
                    h6 {
                        margin: var(--cs-theme-h6-margin-tablet-landscape)
                    }

                    .d3:not([hidden])+.h6 {
                        margin-top: var(--cs-theme-h6-after-d3-margin-top-tablet-landscape)
                    }

                }

                @media only screen and (min-width:1456px) {

                    .h6,
                    h6 {
                        font-size: var(--cs-theme-h6-font-size-desktop);
                        letter-spacing: var(--cs-theme-h6-letter-spacing-desktop);
                        line-height: var(--cs-theme-h6-line-height-desktop)
                    }

                    h6 {
                        margin: var(--cs-theme-h6-margin-desktop)
                    }

                    .d3:not([hidden])+.h6 {
                        margin-top: var(--cs-theme-h6-after-d3-margin-top-desktop)
                    }

                }




                .l1,
                .l2 {
                    font-family: var(--cs-theme-secondary-font-family);
                    transition: opacity var(--cs-interface-expansion)
                }

                :host([wf-loading]) .l1,
                :host([wf-loading]) .l2 {
                    opacity: 0
                }

                .l1-brand-light,
                .l1-light,
                .l2-brand-light,
                .l2-light {
                    color: var(--cs-light-color)
                }

                .l1 {
                    font-size: var(--cs-theme-l1-font-size-mobile);
                    font-weight: var(--cs-theme-l2-font-weight);
                    letter-spacing: var(--cs-theme-l1-letter-spacing);
                    line-height: var(--cs-theme-l1-line-height-mobile);
                    margin: var(--cs-theme-l1-margin-mobile);
                    text-transform: none
                }

                @media only screen and (min-width:1024px) {
                    .l1 {
                        font-size: var(--cs-theme-l1-font-size-tablet-landscape);
                        line-height: var(--cs-theme-l1-line-height-tablet-landscape);
                        margin: var(--cs-theme-l1-margin-tablet-landscape)
                    }

                }

                @media only screen and (min-width:1456px) {
                    .l1 {
                        font-size: var(--cs-theme-l1-font-size-desktop);
                        line-height: var(--cs-theme-l1-line-height-desktop);
                        margin: var(--cs-theme-l1-margin-desktop)
                    }

                }

                .l2 {
                    font-size: var(--cs-theme-l2-font-size-mobile);
                    font-weight: var(--cs-theme-l2-font-weight);
                    line-height: var(--cs-theme-l2-line-height-mobile);
                    margin: var(--cs-theme-l2-margin-mobile);
                    text-transform: none
                }

                @media only screen and (min-width:1024px) {
                    .l2 {
                        font-size: var(--cs-theme-l2-font-size-tablet-landscape);
                        line-height: var(--cs-theme-l2-line-height-tablet-landscape);
                        margin: var(--cs-theme-l2-margin-tablet-landscape)
                    }

                }

                @media only screen and (min-width:1456px) {
                    .l2 {
                        font-size: var(--cs-theme-l2-font-size-desktop);
                        line-height: var(--cs-theme-l2-line-height-desktop);
                        margin: var(--cs-theme-l2-margin-desktop)
                    }

                }
            </style>
		</custom-style>
	</template>
</dom-module>`;
document.head.appendChild($_documentContainer.content);
